<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Quản lý sửa chữa - bảo hành - bảo trì</div>
      </div>
      <div class="card card-w-title" v-if="display_page">
        <ProgressbarSteps :list_process="list_process" :status_active="status_active" :key="key_process"></ProgressbarSteps>
        <div class="box-top-list">
          <span class="p-m-0 title_group">{{ (formMode == 'edit') ? 'THÔNG TIN DỊCH VỤ':'TRA CỨU SẢN PHẨM' }}</span>
          <span class="right-button">
            <Button class="p-button-warning" :label="'Quay lại'" @click="backList"/>
            <Button
                v-if="$myConstants.isEmpty(objectLoadData.process_status)"
                class="btn-custom"
                :label="'Tiếp nhận và sửa chữa'"
                type="button"
                @click="saveData(true)"
            > </Button>
            <Button v-if="$myConstants.isEmpty(objectLoadData.process_status)" :disabled="submitForm" class="p-button-success btn-custom" :label="labelName" @click="saveData(false)"/><!--saveData-->
            <!--Tiếp nhận yêu cầu-->
            <Button
                v-if="!$myConstants.isEmpty(objectLoadData.process_status) && objectLoadData.process_status == $dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_RECEIVED"
                class="btn-custom"
                :label="'Tiếp nhận và sửa chữa'"
                type="button"
                @click="update_status_wr($dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_IMPLEMENTATION,1)"
            > </Button>
            <Button v-if="!$myConstants.isEmpty(objectLoadData.process_status) && objectLoadData.process_status == $dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_RECEIVED" :disabled="submitForm" class="p-button-success btn-custom" :label="'Tiếp nhận'" @click="update_status_wr($dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_IMPLEMENTATION,0)"/><!--saveData-->

            <Button v-if="!$myConstants.isEmpty(objectLoadData.process_status) && objectLoadData.process_status == $dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.SEND_REQUIRE"  class="btn-custom" :label="'Xác nhận'" @click="update_status_wr($dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_RECEIVED,0)"/>
            <Button :disabled="disable_btn_waiting_delivery" v-if="!$myConstants.isEmpty(objectLoadData.process_status) && objectLoadData.process_status == $dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_IMPLEMENTATION"  class="btn-custom" :label="'Chờ giao trả'" @click="update_status_wr($dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_DELIVERY,1)"/>
            <Button v-if="!$myConstants.isEmpty(objectLoadData.process_status) && objectLoadData.process_status == $dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_DELIVERY"  class="btn-custom" :label="'Giao thành công'" @click="update_status_wr($dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.COMPLETE,1)"/>
          </span>
          <div class="clearfix"></div>
        </div>
        <div class="list-data-permission">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-col-12">
              <div class="p-grid">
            <div class="p-field p-col-12 p-md-6" v-if="formMode != 'edit'">
              <div class="p-col-12">
                <label class="style_lable">Serial number</label>
                <div>
                  <InputText autocomplete="off" placeholder="Nhập serial number" style="background-color: #f8f8f8;width: 200px"  id="code" type="text" v-model="serial_number_lookup"/>
                  <Button @click="showLookupProduct" style="width: 120px;height: 40px;text-align: center;margin-left: 16px;background: linear-gradient( 180deg, rgba(66, 139, 202, 1) 0%, rgba(66, 139, 202, 1) 0%, rgba(45, 108, 162, 1) 100%, rgba(45, 108, 162, 1) 100%);font-size: 14px; color: #FFFFFF;font-weight: 700; font-style: normal;border-color: rgba(40, 94, 142, 1);" class="p-button-success btn-custom" :label="'Tra cứu'"/>
                  <small v-if="validationErrors && validationErrors['list_product_serial']" class="p-invalid" >{{validationErrors['list_product_serial']}}</small>
                </div>
              </div>
            </div>
            <div class="p-field p-col-12 p-md-6" v-if="formMode == 'edit'">
              <div class="p-col-12">
              <div class="p-field box_group_item">
                <div class="form-info">
                  <div class="p-field">
                    <label>Mã dịch vụ</label>
                    <div class="box-value style_lable" >
                      <span >{{ (!$myConstants.isEmpty(objectLoadData.code)) ? objectLoadData.code:''  }}</span>
                    </div>
                  </div>
                  <div class="p-field">
                    <label>Đơn vị thực hiện</label>
                    <div class="box-value" >
                      <span >{{ (!$myConstants.isEmpty(objectLoadData.organization_modifier_name)) ? objectLoadData.organization_modifier_name:''  }}</span>
                    </div>
                  </div>
                  <div class="p-field">
                    <label>Người cập nhật</label>
                    <div class="box-value" >
                      <span >{{ (!$myConstants.isEmpty(objectLoadData.modifier_name)) ? objectLoadData.modifier_name:''  }}</span>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>
            </div>
            </div>
            <div class="p-col-12">
              <div class="p-grid">
            <div class="p-field p-col-12 p-md-12">
              <div :class="'p-col-12 list_product_serial'+((!$myConstants.isEmpty( objectDataWarrantyRepair.process_status) && ( objectDataWarrantyRepair.process_status == $dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.SEND_REQUIRE || objectDataWarrantyRepair.process_status == $dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_RECEIVED )) ? ' remove_scroll_list_serial':'') ">
                <div class="title_group">DANH SÁCH SẢN PHẨM</div>
                <!--:classDatatable="'service_park_ss'"   thêm class phẩn biệt để hiển th5i số lượng-->
                <BaseCommonList
                    :classDatatable="'list_product_serial '"
                    :countCheckBox="true"
                    :labelHeaderAction="'Xóa'"
                    :key="list_product_serial.componentKey"
                    :listData="list_product_serial.listData"
                    :model="list_product_serial.dataModel"
                    :filterDefault="list_product_serial.filters"
                    :columnsDisplays="list_product_serial.columnsDisplays"
                    :pagination="true"
                    v-on:action-click="onActionClickedSerial"
                    :actions="getRowActionsSerial()"
                    :column_footer="list_product_serial.rowFooterProductSerial"
                    @callback="callbackProductSerial"
                ></BaseCommonList><!--:columnsDisplays="list_product_serial.columnsDisplays"  ẩn cột-->
              </div>
            </div>
            </div>
            </div>
            <div class="p-col-12" v-if="$myConstants.isEmpty(objectLoadData.process_status) || objectLoadData.process_status < 2 ">
            <div class="p-grid">
            <div class="p-field p-col-12 p-md-6" style="border-right: 1px solid #ccc;" >
              <div class="p-col-12">
                <div class="title_group">THÔNG TIN TIẾP NHẬN</div>
              </div>
              <div>
                <div class="p-col-12" v-if="!$myConstants.isEmpty( objectDataWarrantyRepair.process_status) && ( objectDataWarrantyRepair.process_status == $dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.SEND_REQUIRE || objectDataWarrantyRepair.process_status == $dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_RECEIVED )">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-6">
                      <label class="style_lable">Ngày gửi yêu cầu</label>
                      <Calendar :disabled="true"  v-model="objectDataWarrantyRepair.request_submission_date" :showIcon="true" />
                    </div>
                    <div class="p-field p-col-6" v-if="objectDataWarrantyRepair.process_status == $dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_RECEIVED">
                      <label class="style_lable">Ngày tiếp nhận<span class="error">*</span></label>
                      <Calendar :disabled="disable_send_require" :minDate="getMinDateCurret()" @input="changeInput($event,'receive')"  v-model="objectDataWarrantyRepair.receive_day_reception" :showIcon="true" />
                      <small v-if="validationErrors && validationErrors['receive_day_reception']" class="p-invalid" >{{validationErrors['receive_day_reception']}}</small>
                    </div>
                  </div>
                </div>
              <div class="p-col-6" v-else>
                <label class="style_lable">Ngày tiếp nhận<span class="error">*</span></label>
                <Calendar :disabled="disable_send_require" :minDate="getMinDateCurret()" @input="changeInput($event,'receive')" id="icon" v-model="objectDataWarrantyRepair.receive_day_reception" :showIcon="true" />
                <small v-if="validationErrors && validationErrors['receive_day_reception']" class="p-invalid" >{{validationErrors['receive_day_reception']}}</small>
              </div>
              </div>
              <div class="p-col-12">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col">
                    <label class="style_lable">Đối tượng gửi<span class="error">*</span></label>
                    <Dropdown :disabled="disable_send_require || disable_waiting_receive" class="width-300" :filter="true" v-model="objectDataWarrantyRepair.receive_sender" :options="list_receive_sender" optionLabel="lable" optionValue="value" @change="change_object_dropdown($event,'receive')"/>
                  </div>
                  <div class="p-field p-col">
                    <label class="style_lable">Đơn vị làm việc</label>
                    <Dropdown :disabled="objectDataWarrantyRepair.receive_sender == 0 || disable_send_require || disable_waiting_receive" class="width-300" :filter="true" v-model="objectDataWarrantyRepair.receive_organization_id" :options="list_receive_organization" optionLabel="name" optionValue="id" placeholder="Chọn đơn vị" @change="change_organization_dropdown($event,'receive')"/>
                    <small v-if="validationErrors && validationErrors['receive_organization_id'] && objectDataWarrantyRepair.receive_sender == 1" class="p-invalid" >{{validationErrors['receive_organization_id']}}</small>
                  </div>
                </div>
              </div>
              <div class="p-col-12">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col">
                    <label class="style_lable">SĐT người gửi<span class="error">*</span></label>
                    <div style="width: calc(100% - 70px);float: left">
                      <span class="p-input-icon-right" >
                         <!-- <i class="pi pi-search"/>--><!--@item-select="clickUsers" @clear="clearUsers" -->
                        <!--:disabled="objectDataWarrantyRepair.receive_sender == 1"-->
                        <AutoComplete :disabled="disable_send_require || disable_waiting_receive" :dropdown="true"  forceSelection class="width-300 autocomplete-custom"  field="group_title" @item-select="clickUsersCustomer($event,'receive')" @clear="clearUsersCustomer('receive')"  v-model="selectedReceiveUsers" :suggestions="list_receive_user" @complete="searchUsersCustomer($event,'receive')" placeholder="Tìm kiếm SĐT"/>
                        <small v-if="validationErrors && validationErrors['receive_user_id'] " class="p-invalid" >{{validationErrors['receive_user_id']}}</small>
                        </span><!--&& objectDataWarrantyRepair.receive_sender == 0-->
                    </div>
                    <div @click="showCustomer('receive')" class="box_add_customer" :style="(objectDataWarrantyRepair.receive_sender == 1) ? 'background-color: rgba(215, 215, 215, 1);':''"><!--display: flex; justify-content: center; align-items: center;-->
                      <img :src="ic_add_user"/>
                    </div>
                  </div>
                  <div class="p-field p-col">
                    <label class="style_lable">Tên người gửi<span class="error">*</span></label>
                    <InputText :disabled="true" type="text" v-model="nameReceiveUsers" />
                  </div>
                </div>
              </div>
              <div class="p-col-12">
                <label class="style_lable">Hình thức tiếp nhận<span class="error">*</span></label>
                <div class="group_radio_button">
                  <div class="p-field-radiobutton radio_product_apply">
                    <RadioButton id="product_apply_1" name="city" value="0" v-model="objectDataWarrantyRepair.receive_method"/>
                    <label for="product_apply_1" class="radio_lable_product_apply">Tại trung tâm bảo hành</label>
                  </div>
                  <div class="p-field-radiobutton radio_product_apply" style="margin-top: 8px;">
                    <RadioButton id="product_apply_2" name="city" value="1" v-model="objectDataWarrantyRepair.receive_method"/>
                    <label for="product_apply_2" class="radio_lable_product_apply">Dịch vụ hỗ trợ tận nơi</label>
                  </div>
                </div>
              </div>
              <div>
              <div class="p-col-12" v-if="objectDataWarrantyRepair.process_status == $dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.SEND_REQUIRE || objectDataWarrantyRepair.process_status == $dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_RECEIVED">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col">
                    <label class="style_lable">Thông tin liên hệ</label>
                    <Textarea :disabled="disable_send_require || disable_waiting_receive" style="min-height: 179px" rows="7" v-model="objectDataWarrantyRepair.receive_contact_info_text" :autoResize="true"/>
                  </div>
                  <div class="p-field p-col">
                    <label class="style_lable">Ghi chú</label>
                    <Textarea   v-model="objectDataWarrantyRepair.receive_note" style="min-height: 179px" rows="7" :autoResize="true"/>
                  </div>
                </div>
              </div>
              <div class="p-col-12" v-else>
                <label class="style_lable">Ghi chú</label>
                <Textarea id="description" rows="7" v-model="objectDataWarrantyRepair.receive_note" :autoResize="true"/>
              </div>
              </div>
            </div>
            <div class="p-field p-col-12 p-md-6" v-if="objectDataWarrantyRepair.receive_method == '0' && objectDataWarrantyRepair.process_status != $dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.SEND_REQUIRE">
              <div class="p-col-12">
                <div class="title_group">THÔNG TIN GIAO TRẢ</div>
              </div>
              <div class="p-col-6">
                <label class="style_lable">Ngày hẹn trả<span class="error">*</span></label>
                <Calendar :minDate="objectDataWarrantyRepair.min_date_delivery_return_appointment_day" @input="changeInput($event,'delivery')"  id="icon" v-model="objectDataWarrantyRepair.delivery_return_appointment_day" :showIcon="true" />
                <small v-if="validationErrors && validationErrors['delivery_return_appointment_day']" class="p-invalid" >{{validationErrors['delivery_return_appointment_day']}}</small>
              </div>
              <div class="p-col-12">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col">
                    <label class="style_lable">Đối tượng nhận<span class="error">*</span></label>
                    <Dropdown class="width-300" :filter="true" v-model="objectDataWarrantyRepair.delivery_relative_receiving" :options="list_delivery_relative_receiving" optionLabel="lable" optionValue="value" @change="change_object_dropdown($event,'delivery')" />
                    <small v-if="validationErrors && validationErrors['receive_sender'] " class="p-invalid" >{{validationErrors['receive_sender']}}</small>
                  </div>
                  <div class="p-field p-col">
                    <label class="style_lable">Đơn vị làm việc</label>
                    <Dropdown :disabled="objectDataWarrantyRepair.delivery_relative_receiving != 2" class="width-300" :filter="true" v-model="objectDataWarrantyRepair.delivery_organization_id" :options="list_receive_organization" optionLabel="name" optionValue="id" placeholder="Chọn đơn vị" @change="change_organization_dropdown($event,'delivery')"/>
                    <small  v-if="validationErrors && validationErrors['delivery_organization_id'] && objectDataWarrantyRepair.delivery_relative_receiving == 2" class="p-invalid" >{{validationErrors['delivery_organization_id']}}</small>
                  </div>
                </div>
              </div>
              <div class="p-col-12">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col">
                    <label class="style_lable">SĐT người nhận <span class="error">*</span></label>
                    <div style="width: calc(100% - 70px);float: left">
                      <span class="p-input-icon-right" >
                          <!--<i class="pi pi-search"/>-->
                        <AutoComplete :disabled="objectDataWarrantyRepair.delivery_relative_receiving == 0" :dropdown="true"  forceSelection class="width-300 autocomplete-custom"  field="group_title" @item-select="clickUsersCustomer($event,'delivery')" @clear="clearUsersCustomer('delivery')"  v-model="selectedDeliveryUser" :suggestions="list_delivery_user" @complete="searchUsersCustomer($event,'delivery')" placeholder="Tìm kiếm SĐT"/>
                        <small v-if="validationErrors && validationErrors['delivery_user_id'] " class="p-invalid" >{{validationErrors['delivery_user_id']}}</small>
                        </span>
                    </div>
                    <div @click="showCustomer('delivery')" class="box_add_customer" :style="(objectDataWarrantyRepair.delivery_relative_receiving != 1) ? 'background-color: rgba(215, 215, 215, 1);':''"><!--display: flex; justify-content: center; align-items: center;-->
                      <img style=""  :src="ic_add_user"/>
                    </div>

                  </div>
                  <div class="p-field p-col">
                    <label class="style_lable">Tên người nhận<span class="error">*</span></label>
                    <InputText :disabled="true" type="text" v-model="nameDeliveryUser" />
                  </div>
                </div>
              </div>
              <div class="p-col-12">
                <label class="style_lable">Hình thức giao trả<span class="error">*</span></label>
                <div class="group_radio_button">
                  <div class="p-field-radiobutton radio_product_apply">
                    <RadioButton id="delivery_method_1" name="city" value="0" v-model="objectDataWarrantyRepair.delivery_method"/>
                    <label for="delivery_method_1" class="radio_lable_product_apply">Tại trung tâm bảo hành</label>
                  </div>
                  <div class="p-field-radiobutton radio_product_apply" style="margin-top: 8px;">
                    <RadioButton id="delivery_method_2" name="city" value="1" v-model="objectDataWarrantyRepair.delivery_method"/>
                    <label for="delivery_method_2" class="radio_lable_product_apply">Giao tận nơi người nhận</label>
                  </div>
                </div>
                <small v-if="validationErrors && validationErrors['delivery_method'] " class="p-invalid" >{{validationErrors['delivery_method']}}</small>
              </div>

              <div class="p-col-12" style="padding-bottom: 0px" v-if="objectDataWarrantyRepair.delivery_method == '1'">
                <div class="style_lable">Địa chỉ nhận<span class="error">*</span></div>
                <small v-if="validationErrors && validationErrors['delivery_address']" class="p-invalid" >{{validationErrors['delivery_address']}}</small>
              </div>
              <div class="p-col-12" v-if="objectDataWarrantyRepair.delivery_method == '1'">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col">
                    <label>Tỉnh/Thành phố</label>
                    <Dropdown @change="changeProvince($event)" class="width-300" :filter="true" v-model="objectDataWarrantyRepair.delivery_province_id" :options="list_province" optionLabel="name" optionValue="id" placeholder="Chọn tỉnh/thành phố"/>
                  </div>
                  <div class="p-field p-col">
                    <label>Quận/Huyện</label>
                    <Dropdown @change="changeDistrict($event)" class="width-300" :filter="true" v-model="objectDataWarrantyRepair.delivery_district_id" :options="list_district" optionLabel="name" optionValue="id" placeholder="Chọn quận/huyện"/>
                  </div>
                </div>
              </div>
              <div class="p-col-12" v-if="objectDataWarrantyRepair.delivery_method == '1'">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col">
                    <label>Phường/Xã</label>
                    <Dropdown class="width-300" :filter="true" v-model="objectDataWarrantyRepair.delivery_ward_id" :options="list_ward"  optionLabel="name" optionValue="id" placeholder="Chọn phường/xã"/>
                  </div>
                  <div class="p-field p-col">
                    <label>Số nhà</label>
                    <InputText autocomplete="off" type="text" v-model="objectDataWarrantyRepair.delivery_apartment_number" />
                  </div>
                </div>
              </div>
            </div>
            </div>
            </div>

            <div class="p-col-12" v-if="(!this.$myConstants.isEmpty(objectLoadData.process_status)) && objectLoadData.process_status > 1 ">
              <div class="p-grid">
                <div class="p-field p-col-12 p-md-6" >
                  <div class="p-col-12">
                    <div class="title_group">THÔNG TIN TIẾP NHẬN</div>
                  </div>
                    <div class="p-col-12">
                      <div class="p-field box_group_item">
                        <div class="form-info">
                          <div class="p-field">
                            <label>Ngày tiếp nhận</label>
                            <div class="box-value" >
                              <span >{{ (!$myConstants.isEmpty(objectLoadData.receive_day_reception_text)) ? objectLoadData.receive_day_reception_text:''  }}</span>
                            </div>
                          </div>
                          <div class="p-field">
                            <label>Đối tượng gửi</label>
                            <div class="box-value" >
                              <span >{{ (!$myConstants.isEmpty(objectLoadData.receive_sender_text)) ? objectLoadData.receive_sender_text:''  }}</span>
                            </div>
                          </div>
                          <div class="p-field" v-if="objectLoadData.receive_sender == 1">
                            <label>Đơn vị làm việc</label>
                            <div class="box-value" >
                              <span >{{ (!$myConstants.isEmpty(objectLoadData.receive_organization_text)) ? objectLoadData.receive_organization_text:''  }}</span>
                            </div>
                          </div>
                          <div class="p-field" ><!--v-if="objectLoadData.receive_sender == 0"-->
                            <label>Tên người gửi</label>
                            <div class="box-value" >
                              <span >{{ (!$myConstants.isEmpty(objectLoadData.receive_user_text)) ? objectLoadData.receive_user_text:''  }}</span>
                            </div>
                          </div>
                          <div class="p-field" ><!--v-if="objectLoadData.receive_sender == 0"-->
                            <label>SĐT người gửi</label>
                            <div class="box-value" >
                              <span >{{ (!$myConstants.isEmpty(objectLoadData.receive_user_phone_text)) ? objectLoadData.receive_user_phone_text:''  }}</span>
                            </div>
                          </div>
                          <div class="p-field">
                            <label>Hình thức tiếp nhận</label>
                            <div class="box-value" >
                              <span >{{ (!$myConstants.isEmpty(objectLoadData.receive_method_text)) ? objectLoadData.receive_method_text:''  }}</span>
                            </div>
                          </div>
                          <div class="p-field" v-if="objectDataWarrantyRepair.is_fix_send_request == 1">
                            <label> Thông tin liên hệ</label>
                            <div class="box-value" >
                              <span >{{ (!$myConstants.isEmpty(objectDataWarrantyRepair.receive_contact_info_text)) ? objectDataWarrantyRepair.receive_contact_info_text:''  }}</span>
                            </div>
                          </div>
                          <div class="p-field">
                            <label>Ghi chú</label>
                            <div class="box-value" >
                              <span >{{ (!$myConstants.isEmpty(objectLoadData.receive_note)) ? objectLoadData.receive_note:''  }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                </div>
                <div :class="'p-field p-col-12 p-md-6'+((objectLoadData.process_status > 1 && objectLoadData.process_status < 4) ? ' boder-left':'')" v-if="objectLoadData.receive_method.toString() == '0' && objectDataWarrantyRepair.key_process != 1">
                  <div class="p-col-12">
                    <div v-if="objectLoadData.process_status > 1 && objectLoadData.process_status < 4 ">
                      <div style="float: left" class="title_group">THÔNG TIN GIAO TRẢ</div>
                      <Button style="float: right;width: 96px;"
                              v-if="objectLoadData.process_status > 1 && objectLoadData.process_status < 4 "
                              :disabled="submitForm" class="p-button-success btn-custom" :label="'Lưu'"
                              @click="saveDataDelivery()"/>

                    </div>
                    <div v-else>
                      <div class="title_group">THÔNG TIN GIAO TRẢ</div>
                    </div>
                  </div>
                  <div class="p-col-12">
                    <div class="p-field box_group_item" v-if="objectLoadData.process_status == 4">
                      <div class="form-info">
                        <div class="p-field">
                          <label>Ngày hẹn trả</label>
                          <div class="box-value" >
                            <span >{{ (!$myConstants.isEmpty(objectLoadData.delivery_return_appointment_day_text)) ? objectLoadData.delivery_return_appointment_day_text:''  }}</span>
                          </div>
                        </div>
                        <div class="p-field">
                          <label>Đối tượng nhận</label>
                          <div class="box-value" >
                            <span >{{ (!$myConstants.isEmpty(objectLoadData.delivery_relative_receiving_text)) ? objectLoadData.delivery_relative_receiving_text:''  }}</span>
                          </div>
                        </div>
                        <div class="p-field" v-if="objectLoadData.delivery_relative_receiving == 2 || (objectLoadData.delivery_relative_receiving == 0 && objectLoadData.receive_sender == 1) ">
                          <label>Đơn vị làm việc</label>
                          <div class="box-value" >
                            <span >{{ (!$myConstants.isEmpty(objectLoadData.delivery_organization_text)) ? objectLoadData.delivery_organization_text:''  }}</span>
                          </div>
                        </div>
                        <div class="p-field" ><!--v-if="objectLoadData.delivery_relative_receiving == 1"-->
                          <label>Tên người nhận</label>
                          <div class="box-value" >
                            <span >{{ (!$myConstants.isEmpty(objectLoadData.delivery_user_text)) ? objectLoadData.delivery_user_text:''  }}</span>
                          </div>
                        </div>
                        <div class="p-field" ><!--v-if="objectLoadData.delivery_relative_receiving == 1"-->
                          <label>SĐT người nhận</label>
                          <div class="box-value" >
                            <span >{{ (!$myConstants.isEmpty(objectLoadData.delivery_user_phone_text)) ? objectLoadData.delivery_user_phone_text:''  }}</span>
                          </div>
                        </div>
                        <div class="p-field">
                          <label>Hình thức giao trả</label>
                          <div class="box-value" >
                            <span >{{ (!$myConstants.isEmpty(objectLoadData.delivery_method_text)) ? objectLoadData.delivery_method_text:''  }}</span>
                          </div>
                        </div>
                        <div class="p-field" v-if="!$myConstants.isEmpty(objectLoadData.delivery_method) && objectLoadData.delivery_method.toString() == '1'">
                          <label>Địa chỉ nhận</label>
                          <div class="box-value" >
                            <span >{{ (!$myConstants.isEmpty(objectLoadData.delivery_address_full)) ? objectLoadData.delivery_address_full:''  }}</span>
                          </div>
                        </div>
                        <div class="p-field" >
                          <label>Ghi chú giao trả 1 phần</label>
                          <div class="box-value" >
                            <span >{{ (!$myConstants.isEmpty(objectLoadData.note_delivery)) ? objectLoadData.note_delivery:''  }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="box_save_delivery" v-else>
                      <div class="p-col-6">
                        <label class="style_lable">Ngày hẹn trả<span class="error">*</span></label>
                        <Calendar :minDate="objectDataWarrantyRepair.min_date_delivery_return_appointment_day" @input="changeInput($event,'delivery')"  id="icon" v-model="objectDataWarrantyRepair.delivery_return_appointment_day" :showIcon="true" />
                        <small v-if="validationErrors && validationErrors['delivery_return_appointment_day']" class="p-invalid" >{{validationErrors['delivery_return_appointment_day']}}</small>
                      </div>
                      <div class="p-col-12">
                        <div class="p-fluid p-formgrid p-grid">
                          <div class="p-field p-col">
                            <label class="style_lable">Đối tượng nhận<span class="error">*</span></label>
                            <Dropdown class="width-300" :filter="true" v-model="objectDataWarrantyRepair.delivery_relative_receiving" :options="list_delivery_relative_receiving" optionLabel="lable" optionValue="value" @change="change_object_dropdown($event,'delivery')" />
                            <small v-if="validationErrors && validationErrors['receive_sender'] " class="p-invalid" >{{validationErrors['receive_sender']}}</small>
                          </div>
                          <div class="p-field p-col">
                            <label class="style_lable">Đơn vị làm việc</label>
                            <Dropdown :disabled="objectDataWarrantyRepair.delivery_relative_receiving != 2" class="width-300" :filter="true" v-model="objectDataWarrantyRepair.delivery_organization_id" :options="list_receive_organization" optionLabel="name" optionValue="id" placeholder="Chọn đơn vị"  @change="change_organization_dropdown($event,'delivery')"/>
                            <small  v-if="validationErrors && validationErrors['delivery_organization_id'] && objectDataWarrantyRepair.delivery_relative_receiving == 2" class="p-invalid" >{{validationErrors['delivery_organization_id']}}</small>
                          </div>
                        </div>
                      </div>
                      <div class="p-col-12">
                        <div class="p-fluid p-formgrid p-grid">
                          <div class="p-field p-col">
                            <label class="style_lable">SĐT người nhận <span class="error">*</span></label>
                            <div style="width: calc(100% - 70px);float: left">
                      <span class="p-input-icon-right" >
                          <!--<i class="pi pi-search"/>-->
                        <AutoComplete :disabled="objectDataWarrantyRepair.delivery_relative_receiving == 0" :dropdown="true"  forceSelection class="width-300 autocomplete-custom"  field="group_title" @item-select="clickUsersCustomer($event,'delivery')" @clear="clearUsersCustomer('delivery')"  v-model="selectedDeliveryUser" :suggestions="list_delivery_user" @complete="searchUsersCustomer($event,'delivery')" placeholder="Tìm kiếm SĐT"/>
                        <small v-if="validationErrors && validationErrors['delivery_user_id']" class="p-invalid" >{{validationErrors['delivery_user_id']}}</small>
                        </span>
                            </div>
                            <div @click="showCustomer('delivery')" class="box_add_customer" :style="(objectDataWarrantyRepair.delivery_relative_receiving != 1) ? 'background-color: rgba(215, 215, 215, 1);':''"><!--display: flex; justify-content: center; align-items: center;-->
                              <img style=""  :src="ic_add_user"/>
                            </div>

                          </div>
                          <div class="p-field p-col">
                            <label class="style_lable">Tên người nhận<span class="error">*</span></label>
                            <InputText :disabled="true" type="text" v-model="nameDeliveryUser" />
                          </div>
                        </div>
                      </div>
                      <div class="p-col-12">
                        <div class="p-fluid p-formgrid p-grid">
                          <div class="p-field p-col">
                            <label class="style_lable">Hình thức giao trả<span class="error">*</span></label>
                            <div class="group_radio_button">
                              <div class="p-field-radiobutton radio_product_apply">
                                <RadioButton id="delivery_method_save_1" name="city" value="0" v-model="objectDataWarrantyRepair.delivery_method"/>
                                <label for="delivery_method_save_1" class="radio_lable_product_apply">Tại trung tâm bảo hành</label>
                              </div>
                              <div class="p-field-radiobutton radio_product_apply" style="margin-top: 8px;">
                                <RadioButton id="delivery_method_save_2" name="city" value="1" v-model="objectDataWarrantyRepair.delivery_method"/>
                                <label for="delivery_method_save_2" class="radio_lable_product_apply">Giao tận nơi người nhận</label>
                              </div>
                            </div>
                          </div>
                          <div class="p-field p-col">
                            <label class="style_lable">Ghi chú giao trả 1 phần</label>
                            <Textarea   v-model="objectDataWarrantyRepair.note_delivery" style="min-height: 100px" rows="7" :autoResize="true"/>
                          </div>
                        </div>
                      </div>

                      <div class="p-col-12" style="padding-bottom: 0px" v-if="objectDataWarrantyRepair.delivery_method == '1'">
                        <div class="style_lable">Địa chỉ nhận<span class="error">*</span></div>
                        <small v-if="validationErrors && validationErrors['delivery_address']" class="p-invalid" >{{validationErrors['delivery_address']}}</small>
                      </div>
                      <div class="p-col-12" v-if="objectDataWarrantyRepair.delivery_method == '1'">
                        <div class="p-fluid p-formgrid p-grid">
                          <div class="p-field p-col">
                            <label>Tỉnh/Thành phố</label>
                            <Dropdown @change="changeProvince($event)" class="width-300" :filter="true" v-model="objectDataWarrantyRepair.delivery_province_id" :options="list_province" optionLabel="name" optionValue="id" placeholder="Chọn tỉnh/thành phố"/>
                          </div>
                          <div class="p-field p-col">
                            <label>Quận/Huyện</label>
                            <Dropdown @change="changeDistrict($event)" class="width-300" :filter="true" v-model="objectDataWarrantyRepair.delivery_district_id" :options="list_district" optionLabel="name" optionValue="id" placeholder="Chọn quận/huyện"/>
                          </div>
                        </div>
                      </div>
                      <div class="p-col-12" v-if="objectDataWarrantyRepair.delivery_method == '1'">
                        <div class="p-fluid p-formgrid p-grid">
                          <div class="p-field p-col">
                            <label>Phường/Xã</label>
                            <Dropdown class="width-300" :filter="true" v-model="objectDataWarrantyRepair.delivery_ward_id" :options="list_ward"  optionLabel="name" optionValue="id" placeholder="Chọn phường/xã"/>
                          </div>
                          <div class="p-field p-col">
                            <label>Số nhà</label>
                            <InputText autocomplete="off" type="text" v-model="objectDataWarrantyRepair.delivery_apartment_number" />
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                </div>
              </div>
            </div>
            <PopupLookup
                v-if="PopupLookup.editDialogKey > 0"
                :key="PopupLookup.editDialogKey"
                :show="PopupLookup.displayDialog"
                :objectData="objectDataSerial"
                :listDataCurrent="list_product_serial.listData"
                @load_product_serial="load_product_serial"
                @add_product_serial_popup="action_product_serial_popup"
                @close_popup_product="close_popup_product"
            ></PopupLookup><!--@refresh="refreshData"-->
            <PopupCustomer
                v-if="PopupCustomer.editDialogKey > 0"
                :key="PopupCustomer.editDialogKey"
                :show="PopupCustomer.displayDialog"
                :module="PopupCustomer.module"
                :screen="'warranty_repair'"
                :dataDefault="PopupCustomer.dataDefault"
                @save_warranty_repair="save_warranty_repair"
            ></PopupCustomer><!--@refresh="refreshData"-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import BaseCommonList from '../common'
import PopupCustomer from '../customer/popup_customer'
import PopupLookup from '../warranty_repair/popup_product_lookup'
import ProgressbarSteps from './progressbar_steps'
import moment from "moment";
//import Module from './module'
export default {
  components: {
    //  Module
    BaseCommonList,
    PopupCustomer,
    PopupLookup,
    ProgressbarSteps
  },
  data() {
    return {
      ic_add_user: window.origin + '/assets/images/ic_add_user.png',
      modelPermissionData: [],
      dataModel: null,
      componentKey: 0,
      modelName: 'roles',
      name: '',
      description: '',
      activeIndex: 0,
      validationErrors: {},
      name_exists: false,
      roleID: 0,
      permissonAllWeb: [],
      permissonAllMobile: [],
      type: 'web',
      disable_btn_waiting_delivery:false,//cờ disable nút chờ giao trả
      submitForm: false,
      is_management_lower_level: false,
      status: true,
      labelName: 'Tiếp nhận',
      titleModel: ' Tạo mới gói dịch vụ',
      city: null,
      listOldServiceSupplies: [],
      list_product_serial:{
        columnsDisplays: [],
        componentKey: 0,
        filters: {},
        listData: [],
        dataModel: null,
        rowFooterProductSerial: null,
      },
      list_dropdown_service_supplies: [],
      selected_service_supplies: null,
      list_dropdown_product: [],
      selected_product: null,
      serial_number_lookup:'',
      objectDataSerial: {},
      objectData: {
        code: '',
        name: '',
        description: '',
        status: true,
        apply_all_model: '1',//SỬ dụng kiểu string mới active dc radio
      },
      PopupServiceSupplies: {
        editDialogKey: 0,
        displayDialog: false,
        dialogMode: 'add',
        modelEdit: {},
        modelName: 'service_supplies',
      },
      listModelProduct: {
        componentKey: 0,
        listData: [],
        listOld: [],
        dataModel: null,
        filters: {},
      },
      PopupCustomer:{
        displayDialog:false,
        editDialogKey:0,
        module:'add_receive',
        dataDefault:{
          phone:null
        },
      },
      PopupLookup:{
        displayDialog:false,
        editDialogKey:0
      },
      formMode: 'add',
      sales: null,
      list_receive_sender:[{value:0,lable:"Khách hàng"},{value:1,lable:"Nhân viên đại lý"}],
      list_receive_organization:[],
      list_receive_user:[],
      selectedReceiveUsers:null,
      nameReceiveUsers:'',
      isPhoneReceiveExist:false,
      phoneReceive:'',
      list_delivery_relative_receiving:[{value:0,lable:"Người gửi"},{value:1,lable:"Khách hàng"},{value:2,lable:"Nhân viên đại lý"}],
      list_delivery_user:[],
      selectedDeliveryUser:null,
      nameDeliveryUser:'',
      isPhoneDeliveryExist:false,
      phoneDelivery:'',
      list_province:[],
      list_district:[],
      list_ward:[],
      date_current:moment().format('DD/MM/yyyy'),
      objectDataWarrantyRepair: {
        request_submission_date:null,
        receive_day_reception: moment().format('DD/MM/yyyy'),
        receive_sender: 0,
        receive_user_id: null,
        receive_organization_id: null,
        receive_note:'',
        note_delivery:'',
        receive_contact_info_text:'',
        delivery_relative_receiving: 0,
        delivery_user_id: null,
        delivery_organization_id: null,
        receive_method: '0',//SỬ dụng kiểu string mới active dc radio
        delivery_return_appointment_day: moment().format('DD/MM/yyyy'),
        min_date_delivery_return_appointment_day:new Date(moment().format()),
        delivery_province_id: null,
        delivery_district_id: null,
        delivery_ward_id: null,
        delivery_apartment_number: '',
        delivery_method: '0',//SỬ dụng kiểu string mới active dc radio
        process_status: null,
        is_fix_send_request:0,//Cờ check đơn này có phải gửi yêu cầu,1.gửi yêu cầu,0.ko phải gửi yêu cầu
        key_process:0,//0.tạo tiếp nhận,1.(Gửi yêu cầu -> done),2.(Gửi yêu cầu ->chờ tiếp nhận -> done)
      },
      objectLoadData:{},//object load data khi nhấn view
      status_warranty: {
        send_require: 0,//Gửi yêu cầu
        waiting_receive: 1,//Chờ tiếp nhận
        waiting_implementation: 2,//Chờ thực hiện
        waiting_delivery: 3,//Chờ giao trả
        done: 4,//Hoàn thành
      },
      disable_send_require:false,
      disable_waiting_receive:false,
      key_process:0,
      status_active: 1,
      list_process:[
        {
          key_step:1,
          process_status:0,
          title:'Gửi yêu cầu'
        },
        {
          key_step:2,
          process_status:1,
          title:'Tiếp nhận'
        },
        {
          key_step:3,
          process_status:2,
          title:'Kiểm tra & thực hiện'
        },
        {
          key_step:4,
          process_status:3,
          title:'Giao trả'
        },
        {
          key_step:5,
          process_status:4,
          title:'Hoàn thành'
        }
      ],
      display_page:true
    }
  },
  async created() {
    this.sales = [
      {product: 'Bamboo Watch', lastYearSale: 51, thisYearSale: 40, lastYearProfit: 54406, thisYearProfit: 43342},
      {product: 'Black Watch', lastYearSale: 83, thisYearSale: 9, lastYearProfit: 423132, thisYearProfit: 312122},
      {product: 'Blue Band', lastYearSale: 38, thisYearSale: 5, lastYearProfit: 12321, thisYearProfit: 8500},
      {product: 'Blue T-Shirt', lastYearSale: 49, thisYearSale: 22, lastYearProfit: 745232, thisYearProfit: 65323},
      {product: 'Brown Purse', lastYearSale: 17, thisYearSale: 79, lastYearProfit: 643242, thisYearProfit: 500332},
      {product: 'Chakra Bracelet', lastYearSale: 52, thisYearSale:  65, lastYearProfit: 421132, thisYearProfit: 150005},
      {product: 'Galaxy Earrings', lastYearSale: 82, thisYearSale: 12, lastYearProfit: 131211, thisYearProfit: 100214},
      {product: 'Game Controller', lastYearSale: 44, thisYearSale: 45, lastYearProfit: 66442, thisYearProfit: 53322},
      {product: 'Gaming Set', lastYearSale: 90, thisYearSale: 56, lastYearProfit: 765442, thisYearProfit: 296232},
      {product: 'Gold Phone Case', lastYearSale: 75, thisYearSale: 54, lastYearProfit: 21212, thisYearProfit: 12533}
    ];
    await this.initData();
  },
  async mounted() {
    /*this.dataModel = DataServices.getModel(this.modelName);
    if (this.$route.params.id !== undefined && !isNaN(this.$route.params.id)) {
      this.roleID = Number(this.$route.params.id);
      await this.getData();
    }*/
  },
  computed: {
    lastYearTotal() {
      let total = 0;
      for(let sale of this.sales) {
        total += sale.lastYearProfit;
      }
      return this.formatCurrency(total);
    },
    thisYearTotal() {
      let total = 0;
      for(let sale of this.sales) {
        total += sale.thisYearProfit;
      }

      return this.formatCurrency(total);
    }
  },
  methods: {
    dangphattrien(){
      alert('Đang phát triển')
    },
    close_popup_product(){
      this.serial_number_lookup = '';
    },
    getMinDateCurret() {
      /*let today = new Date();
      let month = today.getMonth();
      let year = today.getFullYear();
      let prevMonth = (month === 0) ? 11 : month -1;
      let prevYear = (prevMonth === 11) ? year - 1 : year;
      /!*let nextMonth = (month === 11) ? 0 : month + 1;
      let nextYear = (nextMonth === 0) ? year + 1 : year;*!/
      var minDate = new Date();
      minDate.setMonth(prevMonth);
      minDate.setFullYear(prevYear);*/
      return (new Date());
    },
    changeInput($event,key_data) {
      var date = new Date($event);
      if (key_data == 'receive'){
        this.objectDataWarrantyRepair.receive_day_reception = moment(date).format('DD/MM/YYYY');
        //set min date cho ngày trả hẹn
        //Ngày hẹn trả sản phẩm Chỉ hiển thị để chọn những ngày > ngày tiếp nhận
        this.objectDataWarrantyRepair.min_date_delivery_return_appointment_day = new Date(moment(date).format());
      }else if (key_data == 'delivery'){
        this.objectDataWarrantyRepair.delivery_return_appointment_day = moment(date).format('DD/MM/YYYY');
      }
    },
    changeProvince($event) {
      var vm = this;
      var value = $event.value;
      if (!this.$myConstants.isEmpty(value)){
        this.$coreService.getDistrictByIdProvince(value).then(async (data) => {
          vm.list_district = data;
        }).catch(async () => {
          vm.list_district = [];
        });
      }
      //set ward về []
      this.list_ward = [];
    },
    changeDistrict($event) {
      var vm = this;
      var value = $event.value;
      if (!this.$myConstants.isEmpty(value)){
        this.$coreService.getWardByIdDistrict(value).then(async (data) => {
          vm.list_ward = data;
        }).catch(async () => {
          vm.list_ward = [];
        });
      }
    },
    defaultSenderInfo(){
      var vm = this;
      if (this.objectDataWarrantyRepair.delivery_relative_receiving == 0){
        //default thông tin của người gửi nếu THÔNG TIN GIAO TRẢ chọn người gửi
        //console.log("this.selectedReceiveUsers:",this.selectedReceiveUsers);
        var data = this.selectedReceiveUsers;
        if (data){
          this.objectDataWarrantyRepair.delivery_user_id = data.id;
          this.nameDeliveryUser = data.full_name;
          this.selectedDeliveryUser = data;
          if (this.objectDataWarrantyRepair.receive_sender == 1){
            this.objectDataWarrantyRepair.delivery_organization_id = this.objectDataWarrantyRepair.receive_organization_id;
          }else {
            this.objectDataWarrantyRepair.delivery_organization_id = null;
          }
          var data_address = {
            delivery_province_id:(!vm.$myConstants.isEmpty(data.province)) ? data.province.id:'',
            delivery_district_id:(!vm.$myConstants.isEmpty(data.district)) ? data.district.id:'',
            delivery_ward_id:(!vm.$myConstants.isEmpty(data.ward)) ? data.ward.id:'',
            delivery_apartment_number:data.address,
          };
          this.load_address_delivery(data_address);
        }
      }
    }
    ,
    clickUsersCustomer(event,key_data) {
      //var vm = this;
      var data = event.value;
      this.load_autocomplete_user(key_data,data);
    },
    load_autocomplete_user(key_data,data){
      var vm = this;
      if (key_data == 'receive'){
        this.objectDataWarrantyRepair.receive_user_id = data.id;
        this.nameReceiveUsers = data.full_name;
        //set hiển thị sdt
        this.selectedReceiveUsers.group_title = this.selectedReceiveUsers.phone_number.replace('+84', '0');
        //defaul đối tượng và đơn vị
        if (data.user_type == 1){
          //đối tượng khách hàng
          vm.objectDataWarrantyRepair.receive_sender = 0;
          vm.objectDataWarrantyRepair.receive_organization_id = null;
        }else {
          vm.objectDataWarrantyRepair.receive_sender = 1;
          if (!vm.$myConstants.isEmpty(data.organization_account)) {
            if (!vm.$myConstants.isEmpty(data.organization_account.organization)) {
                vm.objectDataWarrantyRepair.receive_organization_id = data.organization_account.organization.id;
            }
          }
        }
        //default nếu thông tin giao trả đang là người gửi
        vm.defaultSenderInfo();
        this.isPhoneReceiveExist = true;
        this.phoneReceive = '';
      }else if (key_data == 'delivery'){
        this.objectDataWarrantyRepair.delivery_user_id = data.id;
        this.nameDeliveryUser = data.full_name;
        //set hiển thị sdt
        this.selectedDeliveryUser.group_title = this.selectedDeliveryUser.phone_number.replace('+84', '0');
        //defaul đối tượng và đơn vị
        if (data.user_type == 1){
          //đối tượng khách hàng
          vm.objectDataWarrantyRepair.delivery_relative_receiving = 1;
          vm.objectDataWarrantyRepair.delivery_organization_id = null;
        }else {
          vm.objectDataWarrantyRepair.delivery_relative_receiving = 2;
          if (!vm.$myConstants.isEmpty(data.organization_account)) {
            if (!vm.$myConstants.isEmpty(data.organization_account.organization)) {
              vm.objectDataWarrantyRepair.delivery_organization_id = data.organization_account.organization.id;
            }
          }
        }

        var data_address = {
          delivery_province_id:(!vm.$myConstants.isEmpty(data.province)) ? data.province.id:'',
          delivery_district_id:(!vm.$myConstants.isEmpty(data.district)) ? data.district.id:'',
          delivery_ward_id:(!vm.$myConstants.isEmpty(data.ward)) ? data.ward.id:'',
          delivery_apartment_number:data.address,
        };

        this.load_address_delivery(data_address);
        this.isPhoneDeliveryExist = true;
        this.phoneDelivery = '';
      }
    },
    load_address_delivery(data){
      var vm = this;
      var delivery_province_id = data.delivery_province_id;
      var delivery_district_id = data.delivery_district_id;
      var delivery_ward_id = data.delivery_ward_id;
      var address = data.delivery_apartment_number;
      if (!this.$myConstants.isEmpty(delivery_province_id)){
        this.objectDataWarrantyRepair.delivery_province_id = delivery_province_id;
        if (!this.$myConstants.isEmpty(delivery_province_id)){
          //load tỉnh /thành phố
          if (!this.$myConstants.isEmpty(delivery_district_id)){
            this.objectDataWarrantyRepair.delivery_district_id = delivery_district_id;
          }
          this.$coreService.getDistrictByIdProvince(delivery_province_id).then(async (data) => {
            vm.list_district = data;
          }).catch(async () => {
            vm.list_district = [];
          });
          //load xã phường
          if (!this.$myConstants.isEmpty(delivery_district_id)){
            if (!this.$myConstants.isEmpty(delivery_district_id)){
              this.objectDataWarrantyRepair.delivery_ward_id = delivery_ward_id;
            }
            this.$coreService.getWardByIdDistrict(delivery_district_id).then(async (data) => {
              vm.list_ward = data;
            }).catch(async () => {
              vm.list_ward = [];
            });
            //load số nhà
            if (!this.$myConstants.isEmpty(delivery_ward_id)){
              this.objectDataWarrantyRepair.delivery_apartment_number = (!this.$myConstants.isEmpty(address)) ? address:'';
            }
          }
        }
      }else {
        vm.list_district = [];
        vm.list_ward = [];
        this.objectDataWarrantyRepair.delivery_province_id = null;
        this.objectDataWarrantyRepair.delivery_district_id = null;
        this.objectDataWarrantyRepair.delivery_ward_id = null;
        this.objectDataWarrantyRepair.delivery_apartment_number = '';
      }
    }
    ,
    clearUsersCustomer(key_data) {
      if (key_data == 'receive'){
        this.objectDataWarrantyRepair.receive_user_id = null;
        this.selectedReceiveUsers =  null;
        this.nameReceiveUsers =  '';
        this.list_receive_user = [];
      }else if (key_data == 'delivery'){
        this.objectDataWarrantyRepair.delivery_user_id = null;
        this.selectedDeliveryUser =  null;
        this.nameDeliveryUser =  '';
        this.list_delivery_user = [];
      }
    },
    async getListCutomerBySearch(keyword) {
      var whereKey = {
        status: {'_in': [1] },
        full_name: {'_neq': ''},
       // phone_number: {'_neq': ''},
        _or: [{phone_number: {_like: "%"+this.$myConstants.replaceAt(keyword, 0, '+84')+"%"}},{phone_number: {_like: "%"+keyword+"%"}}],
        user: {
          user_type: {'_in': [1]}
        }
      }
      /*if (this.$store.getters.fullname.user_type == 2) {
        whereKey = Object.assign(whereKey,  {
          request_activation: {
            author_id: {'_eq': this.$store.getters.fullname.id }
          }
        })
      }*/
      var variables = {
        where_key: whereKey,
        orderBy: {
          //modified_date: 'desc_nulls_last',
          id: 'desc_nulls_last'
        }
      }
      var variablesLimit = variables;
      var dataLimit = await DataServices.getList('customer', {"variables": JSON.stringify(variablesLimit)});
      var listLimit = dataLimit[Object.keys(dataLimit)];
      /*for (var i=0;i<listLimit.length;i++){
        var phone_convert = listLimit[i].phone_number.replace('+84', '0')
        listLimit[i].group_title = phone_convert.replace('+84', '0')+" - "+listLimit[i].full_name;
        listLimit[i].id = listLimit[i].user_id;
      }*/
      return listLimit;
    },
    change_object_dropdown(event,key_data){
      var value = event.value;
      if (key_data == 'receive'){
          //nếu có sự thay đổi default lại dữ liệu
          this.selectedReceiveUsers = null;
          this.objectDataWarrantyRepair.receive_organization_id = null;//ẩn chọn đại lý
          this.objectDataWarrantyRepair.receive_user_id = null;
          this.nameReceiveUsers = '';
      }else if (key_data == 'delivery'){
        if (value == 1 || value == 2){
          this.selectedDeliveryUser = null;
          this.objectDataWarrantyRepair.delivery_organization_id = null;//ẩn chọn đại lý
          this.objectDataWarrantyRepair.delivery_user_id = null;
          this.nameDeliveryUser = '';
        }else if (value == 0){
          this.defaultSenderInfo();
        }

      }
    },
    change_organization_dropdown(event,key_data){
      //var value = event.value;
      if (event);
      if (key_data == 'receive'){
        //nếu có sự thay đổi default lại dữ liệu
        this.selectedReceiveUsers = null;
        this.objectDataWarrantyRepair.receive_user_id = null;
        this.nameReceiveUsers = '';
      }else if (key_data == 'delivery'){
          this.selectedDeliveryUser = null;
          this.objectDataWarrantyRepair.delivery_user_id = null;
          this.nameDeliveryUser = '';
      }
    },
    searchUsersCustomer(event,key_data) {
      var that = this;
      var vm = this;
      var key_map = '';
      var is_get_data = 1;//1.lấy data customer ,2.Lấy data người dùng
      var organization_id = null;
      if (key_data == 'receive'){
        if (that.objectDataWarrantyRepair.receive_sender == 1){
          //Nếu loại là nhân viên thì filter theo người dùng
          is_get_data = 2;
          organization_id = (!that.$myConstants.isEmpty(that.objectDataWarrantyRepair.receive_organization_id)) ? that.objectDataWarrantyRepair.receive_organization_id:null;
        }
        key_map = 'list_receive_user';
      }else if (key_data == 'delivery'){
        if (that.objectDataWarrantyRepair.delivery_relative_receiving == 2){
          is_get_data = 2;
          organization_id = (!that.$myConstants.isEmpty(that.objectDataWarrantyRepair.delivery_organization_id)) ? that.objectDataWarrantyRepair.delivery_organization_id:null;
        }
        key_map = 'list_delivery_user';
      }
      if (is_get_data == 2){
        if (organization_id);
        /*if (this.$myConstants.isEmpty(organization_id)){
          that.$toast.add({
            severity: 'error',
            summary: 'Thông báo',
            detail: 'Vui lòng chọn đơn vị làm việc.',
            life: 3000
          });
          that[key_map] =  [];
          return  false;
        }*/
      }
      if (event.query.trim().length <  5){
        that[key_map] =  [];
        return false
      }
      setTimeout(async () => {
        if (!event.query.trim().length) {
          that[key_map] = [...that.list_receive_user];
          return false
        }
        else {
          var list_object = [];
          var list_data = [];
          /*if (is_get_data == 1){
            list_object = await this.getListCutomerBySearch(event.query.trim());
            for (var i=0;i<list_object.length;i++){
              var phone_convert = list_object[i].phone_number.replace('+84', '0')
              var itemDataCustomer = {
                id:list_object[i].user_id,
                group_title:phone_convert+" - "+list_object[i].full_name,
                phone_number:list_object[i].phone_number,
                full_name:list_object[i].full_name,
                address:(!that.$myConstants.isEmpty(list_object[i].address)) ? list_object[i].address:'',
                province:(!that.$myConstants.isEmpty(list_object[i].province)) ? list_object[i].province:null,
                district:(!that.$myConstants.isEmpty(list_object[i].district)) ? list_object[i].district:null,
                ward:(!that.$myConstants.isEmpty(list_object[i].ward)) ? list_object[i].ward:null,
              }
              list_data.push(itemDataCustomer);
            }
          }else if (is_get_data == 2){
            var keyword = event.query.trim();
            var whereUser = {_or: [{phone_number: {_like: "%"+that.$myConstants.replaceAt(keyword, 0, '+84')+"%"}},{phone_number: {_like: "%"+keyword+"%"}}],}
            list_object = await that.$coreService.get_user_by_organizatio_id(organization_id,whereUser);
            for (var j=0;j<list_object.length;j++){
              var phone_convert_user = list_object[j].phone_number.replace('+84', '0')
              var itemDataUser = {
                id:list_object[j].id,
                group_title:phone_convert_user+" - "+list_object[j].full_name,
                phone_number:list_object[j].phone_number,
                full_name:list_object[j].full_name,
              }
              list_data.push(itemDataUser);
            }
          }*/
          var keyword = event.query.trim();
          var whereUser = {_or: [{phone_number: {_like: "%"+that.$myConstants.replaceAt(keyword, 0, '+84')+"%"}},{phone_number: {_like: "%"+keyword+"%"}}],}
          list_object = await that.$coreService.get_user_search_wr(whereUser);
          for (var j=0;j<list_object.length;j++){
            var phone_convert_user = list_object[j].phone_number.replace('+84', '0')
            var itemDataUser = {
              id:list_object[j].id,
              group_title:phone_convert_user+" - "+list_object[j].full_name,
              phone_number:list_object[j].phone_number,
              full_name:list_object[j].full_name,
              user_type:list_object[j].user_type,
              address:(!that.$myConstants.isEmpty(list_object[j].obj_customer_profile)) ? list_object[j].obj_customer_profile.address:'',
              province:(!that.$myConstants.isEmpty(list_object[j].obj_customer_profile)) ? list_object[j].obj_customer_profile.province:null,
              district:(!that.$myConstants.isEmpty(list_object[j].obj_customer_profile)) ? list_object[j].obj_customer_profile.district:null,
              ward:(!that.$myConstants.isEmpty(list_object[j].obj_customer_profile)) ? list_object[j].obj_customer_profile.ward:null,
            }
            if (!this.$myConstants.isEmpty(list_object[j].organization_account)){
              itemDataUser.organization_account = list_object[j].organization_account;
            }
            list_data.push(itemDataUser);
          }
          if (event.query.trim().length == 10){
            if (list_data.length < 1){
              that.$toast.add({
                severity: 'error',
                summary: 'Thông báo',
                detail: 'Chưa có thông tin khách hàng, vui lòng tạo mới.',
                life: 3000
              });
              if (key_data == 'receive'){
               vm.isPhoneReceiveExist = false;
               vm.phoneReceive = event.query.trim();
              }else if (key_data == 'delivery'){
                vm.isPhoneDeliveryExist = false;
                vm.phoneDelivery = event.query.trim();
              }
            }else {
              if (key_data == 'receive'){
                vm.isPhoneReceiveExist = true;
                this.selectedReceiveUsers = list_data[0];
              }else if (key_data == 'delivery'){
                vm.isPhoneDeliveryExist = true;
                this.selectedDeliveryUser = list_data[0];
              }
              vm.load_autocomplete_user(key_data,list_data[0]);
            }
            vm[key_map] =[];
          }else {
            vm[key_map] =list_data;
          }
        }
      }, 100);
    },
    async getListOrganization() {
      //var organizationLogin = this.$myConstants.organizationUserLogin();
      //var creator_organization_id = (!this.$myConstants.isEmpty(organizationLogin.id)) ? organizationLogin.id:null;
      //var isManagementLevel = this.$myConstants.managementLevel();

      var whereKey = {
        status: {'_in': [ 1] },//0,
      }

      /*var showAll = false;
      if (this.$store.getters.fullname != undefined && this.$store.getters.fullname != null && this.$store.getters.fullname.user_type == 3) {
        showAll = true;
      } else if (this.$store.getters.fullname.user_type == 2) {
        //check quản lý dữ liệu đơn vị
        if (!isManagementLevel) showAll = false;
        else {
          if (this.$store.getters.fullname != undefined && this.$store.getters.fullname != null &&
              this.$store.getters.fullname.organization_account != undefined && this.$store.getters.fullname.organization_account != null &&
              this.$store.getters.fullname.organization_account.organization_id != undefined && this.$store.getters.fullname.organization_account.organization_id != null && this.$store.getters.fullname.organization_account.organization_id > 0) {
            var organizationID = this.$store.getters.fullname.organization_account.organization_id;
            // nếu khác đơn vị gốc
            if (organizationID != this.hardcodeID) {
              showAll = true;
              whereKey = Object.assign(whereKey, {parent_id: {'_eq': organizationID}});
            } else {
              //nếu không có cấp trên
              showAll = (this.$myConstants.levelParent() == 0);
            }
          }
        }
      }

      if(!showAll){
        return [];
      }*/

      //Phân quyền dữ liệu
      /*var is_management_units = false;
      if (parseFloat(this.hardcodeID) ==  creator_organization_id){
        if (!this.$myConstants.isEmpty(this.$store.getters.fullname.is_management_units)){
          if (this.$store.getters.fullname.is_management_units == true){
            is_management_units = true;
          }
        }
      }
      if (is_management_units == false){
        whereKey = Object.assign(whereKey, {parent_id: {'_eq': creator_organization_id}});
      }*/
      var variables = {
        where_key: whereKey,
        orderBy: {
          //modified_date: 'desc_nulls_last',
          id: 'desc'
        }
      }
      var data = await DataServices.getList('organization', {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      return list;
    },
    callbackProductSerial(col, payload) {
      var vm = this;
      if (col.name == 'detail_product_serial') {
        payload.object_data.process_status = (payload.process_status) ? payload.process_status:null;
        payload.object_data.process_status_recieve = (payload.process_status_recieve) ? payload.process_status_recieve:null;
        if (payload.object_data.mode == 'detail') {
          var warranty_repair_product_serial_number_id = payload.object_data.warranty_repair_product_serial_number_id;
          vm.$router.push({path: '/admin/warranty-repair/view-detail/' + warranty_repair_product_serial_number_id});
        }else if (payload.object_data.mode == 'detail_receive'){
          payload.object_data.mode = 'detail_receive';
          this.objectDataSerial = payload.object_data;
          this.PopupLookup.displayDialog = true;
          this.PopupLookup.editDialogKey = Math.floor(Math.random() * (30))
        }
        else {
          payload.object_data.mode = 'edit';
          this.objectDataSerial = payload.object_data;
          this.PopupLookup.displayDialog = true
          this.PopupLookup.editDialogKey = Math.floor(Math.random() * (30))
        }
      }
    },
    formatCurrency(value) {
      return value.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
    },
    async action_product_serial_popup(params){
      var vm = this;
      //console.log("paramsparamsparamsparamsparams:",params)
      var dataChange = {
        id:params.id,
        serial_number:params.object_info_product.serial_number,
        model_code:params.object_info_product.model_code,
        product_name:params.object_info_product.product_name,
        type_service:params.type_service,
        maintenance_period:params.maintenance_period,
        desc_status_product:params.desc_status_product,
        list_img_status_product:params.list_img_status_product,
        process_status:(params.process_status) ? params.process_status:null,
        process_status_recieve:(params.process_status_recieve) ? parseFloat(params.process_status_recieve):null,
        service_total_price_payment:0,
        serial_number_info:'',
        detail_product_serial:'<a href="#">Xem</a>',
        object_data:params
      };
      if (params.mode == 'add'){
        this.list_product_serial.listData.unshift(dataChange);
         vm.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Thêm mới thành công', life: 3000 });
      }else {
        for (var i=0;i<this.list_product_serial.listData.length;i++){
          if (parseFloat(this.list_product_serial.listData[i].id) == parseFloat(params.id)){
            var item_data = this.list_product_serial.listData[i];
            item_data.type_service = params.type_service;
            item_data.maintenance_period = params.maintenance_period;
            item_data.desc_status_product = params.desc_status_product;
            item_data.list_img_status_product = params.list_img_status_product;
            this.list_product_serial.listData[i] = item_data;
            //this.list_product_serial.listData[i] = dataChange;
            break;
          }
        }
        vm.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000 });
      }
      console.log("this.list_product_serial.listData",this.list_product_serial.listData)
      this.list_product_serial.componentKey++;

     /* var data_convert = {
        id:null,
        mode:'add',
        type_service:null,
        maintenance_period:null,
        desc_status_product:'',
        list_img_status_product:[],
        object_info_product:null
      };*/
      //clear data popup khi thêm
      /*this.objectDataSerial = {
        id:null,
        mode:'add',
        type_service:null,
        maintenance_period:null,
        desc_status_product:'',
        list_img_status_product:[],
        object_info_product:null
      };
        this.PopupLookup.displayDialog = true
      this.PopupLookup.editDialogKey = Math.floor(Math.random() * (30))*/
      /*setTimeout(async () => {
        this.list_product_serial.columnsDisplays.push('detail_product_serial')
      }, 1000);*/
    },
    async load_product_serial(params){
      var serial_number_lookup = (!this.$myConstants.isEmpty(params["serial_number_lookup"])) ? params["serial_number_lookup"]:';'
      this.LookupProduct(serial_number_lookup,false);
    },
    async showLookupProduct(){ //show popup tra cứu sản phẩm
      var vm = this;
      this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      setTimeout(function(){ vm.$store.commit('setLoading', false); }, 1000);
      this.LookupProduct(this.serial_number_lookup,true);
    },
    async LookupProduct(serial_number_lookup,is_show = false){ //show popup tra cứu sản phẩm
      if (this.$myConstants.isEmpty(serial_number_lookup)){
        this.$toast.add({
          severity: 'error',
          summary: 'Thông báo',
          detail: 'Vui lòng nhập serial number.',
          life: 3000
        });
        return false;
      }
      if (serial_number_lookup.length != 10) {
        this.$toast.add({
          severity: 'error',
          summary: 'Thông báo',
          detail: 'Không tìm thấy serial number.',
          life: 3000
        });
        return false;
      }
      var checkSerialNumber = await this.checkSerialNumber(serial_number_lookup);
      if (checkSerialNumber){
        var param_convert = {
          mode:'add',
          type_service:null,
          maintenance_period:null,
          desc_status_product:'',
          list_img_status_product:[],
          objectDataSerial:checkSerialNumber
        };
        //var data_convert = this.convertObjectDataSerial(param_convert);
        var data_convert = this.$coreService.convertObjectDataSerial(param_convert);
        this.objectDataSerial = data_convert;
        //console.log("is_showis_showis_show:",is_show)
        if (is_show == true){
          this.PopupLookup.displayDialog = true
        }
        this.PopupLookup.editDialogKey = Math.floor(Math.random() * (30))
      }
    },
    convertObjectDataSerial(param_convert){
      var checkSerialNumber = param_convert.objectDataSerial;
      var data_convert = {
        id:checkSerialNumber.data_info_serial.serial_number_id,
        mode:(!this.$myConstants.isEmpty(param_convert.mode)) ? param_convert.mode:'add',
        type_service:(!this.$myConstants.isEmpty(param_convert.type_service)) ? param_convert.type_service:null,
        maintenance_period:(!this.$myConstants.isEmpty(param_convert.maintenance_period)) ? param_convert.maintenance_period:null,
        desc_status_product:(!this.$myConstants.isEmpty(param_convert.desc_status_product)) ? param_convert.desc_status_product:'',
        list_img_status_product:(param_convert.list_img_status_product && param_convert.list_img_status_product.length>0) ? param_convert.list_img_status_product:[],
        object_info_product:{
          user_id:(checkSerialNumber.user_id) ? checkSerialNumber.user_id:'' ,
          full_name:(checkSerialNumber.full_name) ? checkSerialNumber.full_name:'' ,
          phone_number:(checkSerialNumber.phone_number) ? checkSerialNumber.phone_number:'',
          phone_number_root:(checkSerialNumber.phone_number_root) ? checkSerialNumber.phone_number_root:'',
          group_customer:(checkSerialNumber.group_customer) ? checkSerialNumber.group_customer:'',
          customer_type:(checkSerialNumber.customer_type) ? checkSerialNumber.customer_type:'',
          warranty_status_html:checkSerialNumber.warranty_status_html,
          model_code:(checkSerialNumber.data_info_serial) ? checkSerialNumber.data_info_serial.model_code:'',
          product_name:(checkSerialNumber.data_info_serial) ? checkSerialNumber.data_info_serial.listData.name:'',
          serial_number:(checkSerialNumber.data_info_serial) ? checkSerialNumber.data_info_serial.listData.product_serial_number.serial_number:'' ,
          categories_name:(checkSerialNumber.data_info_serial) ? checkSerialNumber.data_info_serial.listData.categories.name:'',
          warranty_time:checkSerialNumber.data_info_serial.warranty_time,
          change_time:checkSerialNumber.data_info_serial.change_time,
          returnable_time:checkSerialNumber.data_info_serial.returnable_time,
          created_date:(checkSerialNumber.data_info_serial) ? checkSerialNumber.data_info_serial.created_date:'',
          activation_date:(checkSerialNumber.data_info_serial) ? checkSerialNumber.data_info_serial.activation_date:'' ,
          expired_activation_date:(checkSerialNumber.data_info_serial) ? checkSerialNumber.data_info_serial.expired_activation_date:'',
        }
      };
      return data_convert;
    },
    async checkSerialNumber(serial_number_lookup){
      var vm = this;
      var dataRes = await this.$coreService.getSerialWarrantyActivationBySerial(serial_number_lookup);
      //console.log("dataResdataRes:",Object.keys(dataRes))
      if (Object.keys(dataRes).length < 1){
        vm.$toast.add({
          severity: 'error',
          summary: 'Thông báo',
          detail: 'Không tìm thấy serial number.',
          life: 3000
        });
        return null;
      }
      if (dataRes.warranty_status == 6 ){//sản phẩm hủy
        vm.$toast.add({
          severity: 'error',
          summary: 'Thông báo',
          detail: 'Không tìm thấy serial number.',
          life: 3000
        });
        return null;
      }else if (dataRes.warranty_status == 0 || dataRes.warranty_status == 5){
        vm.$toast.add({
          severity: 'error',
          summary: 'Thông báo',
          detail: 'Serial number chưa kích hoạt, vui lòng nhập lại.',
          life: 3000
        });
        return null;
      }else if (dataRes.warranty_status == 2){
        vm.$toast.add({
          severity: 'error',
          summary: 'Thông báo',
          detail: 'Serial number đang chờ kích hoạt, vui lòng nhập lại.',
          life: 3000
        });
        return null;
      }
      return dataRes;
    },
    showCustomer(key_data){
      var module = ''
      if (key_data == 'receive'){
        module = 'add_receive'
        if (this.objectDataWarrantyRepair.receive_sender == 1){
          return false;
        }
        if (this.isPhoneReceiveExist == false){
          this.PopupCustomer.dataDefault.phone = (!this.$myConstants.isEmpty(this.phoneReceive)) ? this.phoneReceive:'';
        }
      }else if (key_data == 'delivery'){
        module = 'add_delivery'
        if (this.objectDataWarrantyRepair.delivery_relative_receiving != 1){
          return false;
        }
        if (this.isPhoneDeliveryExist == false){
          this.PopupCustomer.dataDefault.phone = (!this.$myConstants.isEmpty(this.phoneDelivery)) ? this.phoneDelivery:'';
        }
      }
      this.PopupCustomer.module = module;
      this.PopupCustomer.displayDialog = true;
      this.PopupCustomer.editDialogKey = Math.floor(Math.random() * (30))
    },
    noop () {
      //Chặn redirect submit form
      return false;
    },
    add_model_product() {
      if (!this.selected_product) {
        //alert("Vui lòng chọn");
        this.validationErrors['list_product'] = 'Vui lòng thêm model sản phẩm áp dụng cho gói dịch vụ vào danh sách';
        this.$forceUpdate();
        return false;
      }
      this.validationErrors['list_product'] = '';
          this.listModelProduct.listData.unshift(this.selected_product);//push đầu dòng
      this.selected_product = null;
      var list_id = [];
      for (var i = 0; i < this.listModelProduct.listData.length; i++) {
        list_id.push(this.listModelProduct.listData[i].id);
      }
      this.getOptionProducts(list_id);
      this.listModelProduct.componentKey++;

    },
    async getOptionProducts(not_in_id = []) {
      var vm = this;
      var where = {
        status: {'_in': [1]},
        production_status: {'_eq': 1},
        categories: {
          status: {'_eq': 1}
        }
      };
      if (not_in_id.length > 0) {
        where.id = {'_nin': not_in_id};
      }
      var variables = {
        where_key: where,
        orderBy: {
          name: 'asc',
          created_date: 'desc'
        }
      }
      var data = await DataServices.getList('product', {
        "variables": JSON.stringify(variables),
        "fields": 'id name model_code'
      });
      var list = data[Object.keys(data)];
      if (list != null && Object.keys(list).length) {
        for (let index = 0; index < list.length; index++) {
          var pro = list[index];
          var code = (!vm.$myConstants.isEmpty(pro.model_code)) ? pro.model_code : '';
          var name = (!vm.$myConstants.isEmpty(pro.name)) ? pro.name : '';
          list[index].label = code + ' - ' + name;
        }
        this.list_dropdown_product = this.$myConstants.convertJsonObject(list);
      } else {
        this.list_dropdown_product = [];
      }
    }
    ,
    add_service_supplies() {
      if (!this.selected_service_supplies) {
        this.validationErrors['list_service_supplies'] = 'Vui lòng thêm vật tư - dịch vụ sửa chữa vào danh sách';
        this.$forceUpdate();
        return false;
      }
      //vm.$myConstants.numberFormat(item_data.unit_price, 0, '', '.')
      this.validationErrors['list_service_supplies'] = '';
      //console.log("this.selected_service_supplies:",this.selected_service_supplies)
      var data_add = this.$myConstants.convertJsonObject(this.selected_service_supplies);
      data_add.unit_price = (!this.$myConstants.isEmpty(data_add.unit_price)) ? this.$myConstants.numberFormat(data_add.unit_price, 0, '', '.'):0;
      this.listDataServiceSupplies.unshift(data_add);//push đầu dòng
      this.selected_service_supplies = null;
      var list_id = [];
      for (var i = 0; i < this.listDataServiceSupplies.length; i++) {
        list_id.push(this.listDataServiceSupplies[i].id);
      }
      this.loadSelectServiceSupplies(list_id);
      this.componentKeyServiceSupplies++;

    },
    async save_warranty_repair(payload) {
      //var that = this;
      this.$toast.add({severity: 'success', summary: 'Thông báo', detail: 'Tạo mới thành công', life: 3000})
      if (!this.$myConstants.isEmpty(payload)){
        var dataCustomer = payload.dataCustomer;
        if (dataCustomer.is_enabled == true) {
          //Lấy object khách từ user id để active
          this.defaultCustomer(dataCustomer.id,payload.module);
        }else {
          this.$toast.add({
            severity: 'error',
            summary: 'Thông báo',
            detail: 'Khách hàng đã ngưng hoạt động.',
            life: 3000
          });
        }
      }
      this.PopupCustomer.displayDialog = false;
      this.PopupCustomer.editDialogKey = Math.floor(Math.random() * (30))
    },
   async defaultCustomer(user_id,module){
      var that = this;
      var where = {
        user_id: {_eq: user_id}
      };
      var obj_customer =await DataServices.getObjectData('customer',where,{id: 'desc'});
      //console.log("obj_customerobj_customerobj_customer:",obj_customer)
      var phone_convert = obj_customer.phone_number.replace('+84', '0')
      var itemDataCustomer = {
        id:obj_customer.user_id,
        group_title:phone_convert+" - "+obj_customer.full_name,
        phone_number:obj_customer.phone_number,
        full_name:obj_customer.full_name,
        address:(!that.$myConstants.isEmpty(obj_customer.address)) ? obj_customer.address:'',
        province:(!that.$myConstants.isEmpty(obj_customer.province)) ? obj_customer.province:null,
        district:(!that.$myConstants.isEmpty(obj_customer.district)) ? obj_customer.district:null,
        ward:(!that.$myConstants.isEmpty(obj_customer.ward)) ? obj_customer.ward:null,
      }
      //set chỉ show sdt
      itemDataCustomer.group_title = itemDataCustomer.phone_number.replace('+84', '0');
      if (module == 'add_receive') {
        this.objectDataWarrantyRepair.receive_user_id = user_id;
        this.nameReceiveUsers = obj_customer.full_name;
        this.selectedReceiveUsers = itemDataCustomer;
        that.defaultSenderInfo();
      } else if (module == 'add_delivery') {
        this.objectDataWarrantyRepair.delivery_user_id = user_id;
        this.nameDeliveryUser = obj_customer.full_name;
        this.selectedDeliveryUser = itemDataCustomer;
      }
    },
    onActionClickedAddServiceSupplies(event, payload) {
      var action = payload.action
      event.preventDefault();
      /*if (payload.data) {
        data = payload.data
      }*/
      switch (action.name) {
        case 'add':
          //  if (this.checkVisible('service_supplies', 'add')) {
          this.PopupServiceSupplies.displayDialog = true
          this.PopupServiceSupplies.editDialogKey = Math.floor(Math.random() * (30))
          //}
          break;
      }

    },
    onActionClickedSerial(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      switch (action.name) {
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({path: action.path})
          } else {
            this.displayDialog = true
            this.editDialogKey = Math.floor(Math.random() * (30))
          }
          break;
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({path: action.path + data.data[action.key]})
          } else {
            this.modelEdit = data.data;
            this.displayDialog = true
            this.editDialogKey = Math.floor(Math.random() * (30));
          }
          break;
        case 'delete':
          var id_delete = data.data.id;
          var key_delete = null
          for (var i = 0; i < this.list_product_serial.listData.length; i++) {
            if (parseFloat(id_delete) == parseFloat(this.list_product_serial.listData[i].id)) {
              key_delete = i;
            }
          }
          if (!this.$myConstants.isEmpty(key_delete)) {
            this.list_product_serial.listData.splice(key_delete, 1);
          }
          this.list_product_serial.componentKey++;
          break;
      }
    },
    getRowActionsSerial() {
      var actions = null;
      if ((this.$myConstants.isEmpty(this.objectLoadData.process_status)) ){
        actions = {}
        //var that = this;
        //actions.filter = {name: 'clear', icon: 'times-circle'};
        actions.rows = function (rowData) {
          var buttons = {}
          console.log(rowData)
          /*buttons.view = { name: 'view', text: 'Xem', isText: true, key: 'id', path: `/admin/appraisal-product/view-detail`}
          if (that.dataModel.actions) {
            var modelaction = that.dataModel.actions(rowData)
            Object.assign(buttons, modelaction);
          }*/
          buttons.delete = {name: 'delete', icon: 'trash', key: 'id'}
          return buttons
        }
      }
      return actions
    },
    onActionClickedModelProduct(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      switch (action.name) {
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({path: action.path})
          } else {
            this.displayDialog = true
            this.editDialogKey = Math.floor(Math.random() * (30))
          }
          break;
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({path: action.path + data.data[action.key]})
          } else {
            this.modelEdit = data.data;
            this.displayDialog = true
            this.editDialogKey = Math.floor(Math.random() * (30));
          }
          break;
        case 'delete':
          var id_delete = data.data.id;
          var key_delete = null
          var list_id = [];
          for (var i = 0; i < this.listModelProduct.listData.length; i++) {
            if (parseFloat(id_delete) == parseFloat(this.listModelProduct.listData[i].id)) {
              key_delete = i;
            } else {
              list_id.push(this.listModelProduct.listData[i].id);
            }
          }
          if (!this.$myConstants.isEmpty(key_delete)) {
            this.listModelProduct.listData.splice(key_delete, 1);
          }
          //load lại option
          this.getOptionProducts(list_id);
          //this.componentKeyServiceSupplies++;
          this.listModelProduct.componentKey++;
          break;
      }
    },
    getRowActionsModelProduct() {
      var actions = {}
      //var that = this;
      actions.filter = {name: 'clear', icon: 'times-circle'};
      actions.rows = function (rowData) {
        var buttons = {}
        console.log(rowData)
        /*buttons.view = { name: 'view', text: 'Xem', isText: true, key: 'id', path: `/admin/appraisal-product/view-detail`}
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }*/
        buttons.delete = {name: 'delete', icon: 'trash', key: 'id'}
        return buttons
      }
      return actions
    },
    async loadSelectServiceSupplies(not_in_id = []) {
      var vm = this;//service_supplies_form
      var where =  {
        status: {'_in': [1]},//0,
      };
      if (not_in_id.length > 0){
        where.id = {'_nin': not_in_id}
      }
      var variables_service_supplies = {
        where_key:where,
        orderBy: {
          id: 'desc'
        }
      }
      //load danh sách vật tư
      DataServices.getListData('service_supplies', {"variables": JSON.stringify(variables_service_supplies)}).then(async (res_list) => {
        if (res_list.length > 0) {
          for (var i = 0; i < res_list.length; i++) {
            var code = (!vm.$myConstants.isEmpty(res_list[i].code)) ? res_list[i].code : '';
            var name = (!vm.$myConstants.isEmpty(res_list[i].name)) ? res_list[i].name : '';
            var unit_price = (!vm.$myConstants.isEmpty(res_list[i].unit_price)) ? this.$myConstants.numberFormat(res_list[i].unit_price, 0, '', '.') + 'đ' : '0đ';
            res_list[i].label = code + ' - ' + name + ' - ' + unit_price;
          }
          vm.list_dropdown_service_supplies = vm.$myConstants.convertJsonObject(res_list);
        } else {
          vm.list_dropdown_service_supplies = [];
        }

      }).catch(async () => {

      });
    },
    async initData() {
      this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      var vm = this;
      this.modelName = 'warranty_repair';
      this.getListOrganization().then(async (dataOr) => {
        vm.list_receive_organization = dataOr;
      }).catch(async () => {
        vm.list_receive_organization = [];
      });

      //load danh sách tỉnh/tp
      this.$coreService.getAllProvince().then(async (dataProvince) => {
        vm.list_province = dataProvince;
      }).catch(async () => {
        vm.list_province = [];
      });
      //khởi tạo load danh sách sản phẩm
      this.list_product_serial.dataModel = DataServices.getModel('product_from_warranty_repair');

      var warranty_repair_id = 0;
      if (this.$route.params.id !== undefined && !isNaN(this.$route.params.id)) {
        if (!vm.$myConstants.checkRoleGroup('warranty_repair', 'edit')){
          vm.display_page = false;
        }
        this.labelName = 'Chờ giao trả';
        this.formMode = 'edit';
        warranty_repair_id = this.$route.params.id;
        //get data service pack
        var whereObject = {
          id: {'_eq': warranty_repair_id}
        }
        DataServices.getObjectData('warranty_repair_detail', whereObject, {id: 'desc'}).then(async (resObj) => {
          if (resObj){
            //check điều kiện hiển thị progressbar
            //Nếu ko tồn tại trạng tháp gửi yêu cầu => hiển thị 4step
            //Nếu tồn tại gửi yêu cầu
            //1.Nếu list_process status chỉ có 2 trạng thái (Gửi yêu cầu và Hoàn thành) => hiển thị 2 step ("Gửi yêu cầu","Hoàn thành")
            //2.Ngược lại hiển thị 5 step
            var list_statsus_process_wr = await this.list_statsus_process(warranty_repair_id);
            if (list_statsus_process_wr.indexOf(0) === -1){
              this.display_step([1]);
            }else {
              vm.objectDataWarrantyRepair.is_fix_send_request = 1;
              if (list_statsus_process_wr.length == 2 &&  list_statsus_process_wr.indexOf(vm.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.COMPLETE) > -1 ){
                vm.objectDataWarrantyRepair.key_process = 1;
                this.display_step([2,3,4]);
              }else if (list_statsus_process_wr.length == 3 && list_statsus_process_wr.indexOf(vm.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.COMPLETE) > -1 ){
                //Trường hợp gửi yêu cầu => tiếp nhận => ko chọn đồng ý tiếp nhận (hoàn thành)
                this.display_step([3,4]);
              }
              else {
                this.display_step([]);
              }
            }
            vm.objectLoadData = resObj;
            //active progressbar
            vm.status_active = vm.objectLoadData.process_status;
            this.key_process++;//refesh lại component
            vm.objectLoadData.receive_day_reception_text = (!vm.$myConstants.isEmpty(resObj.receive_day_reception)) ? moment.tz(resObj.receive_day_reception, vm.$myConstants.timeZone()).format('DD/MM/YYYY'):'';
            if ((!vm.$myConstants.isEmpty(resObj.receive_sender))){
              for (var j=0;j<vm.list_receive_sender.length;j++){
                if (parseFloat(vm.list_receive_sender[j].value) == parseFloat(resObj.receive_sender)){
                  vm.objectLoadData.receive_sender_text = vm.list_receive_sender[j].lable;
                  break;
                }
              }
            }
            if ((!vm.$myConstants.isEmpty(resObj.obj_receive_user))) {
              if (resObj.receive_sender == 0) {
                if ((!vm.$myConstants.isEmpty(resObj.obj_receive_user.obj_customer_profile))) {
                  //lấy thông tin khách hàng
                  vm.objectLoadData.receive_user_text = (!vm.$myConstants.isEmpty(resObj.obj_receive_user.obj_customer_profile.full_name)) ? resObj.obj_receive_user.obj_customer_profile.full_name : '';
                  vm.objectLoadData.receive_user_phone_text = (!vm.$myConstants.isEmpty(resObj.obj_receive_user.obj_customer_profile.phone_number)) ? resObj.obj_receive_user.obj_customer_profile.phone_number.replace('+84', '0') : '';
                }
              } else if (resObj.receive_sender == 1) {
                //Lấy thông tin người dùng
                vm.objectLoadData.receive_user_text = (!vm.$myConstants.isEmpty(resObj.obj_receive_user.full_name)) ? resObj.obj_receive_user.full_name : '';
                vm.objectLoadData.receive_user_phone_text = (!vm.$myConstants.isEmpty(resObj.obj_receive_user.phone_number)) ? resObj.obj_receive_user.phone_number.replace('+84', '0') : '';
                if (resObj.obj_receive_user.organization_account){
                  if (resObj.obj_receive_user.organization_account.organization){
                    vm.objectLoadData.receive_organization_text = (resObj.obj_receive_user.organization_account.organization.name) ? resObj.obj_receive_user.organization_account.organization.name:'';//tên đơn vị
                  }
                }
              }
            }
            if ((!vm.$myConstants.isEmpty(resObj.receive_method))){
              if (resObj.receive_method.toString() == '0'){
                vm.objectLoadData.receive_method_text = 'Tại trung tâm bảo hành';
              }else if (resObj.receive_method.toString() == '1'){
                vm.objectLoadData.receive_method_text = 'Dịch vụ hỗ trợ tận nơi';
              }
            }

            vm.objectLoadData.delivery_return_appointment_day_text = (!vm.$myConstants.isEmpty(resObj.delivery_return_appointment_day)) ? moment.tz(resObj.delivery_return_appointment_day, vm.$myConstants.timeZone()).format('DD/MM/YYYY'):'';
            if ((!vm.$myConstants.isEmpty(resObj.delivery_relative_receiving))){
              for (var d=0;d<vm.list_delivery_relative_receiving.length;d++){
                if (parseFloat(vm.list_delivery_relative_receiving[d].value) == parseFloat(resObj.delivery_relative_receiving)){
                  vm.objectLoadData.delivery_relative_receiving_text = vm.list_delivery_relative_receiving[d].lable;
                  break;
                }
              }
            }
            //console.log("resObj.obj_delivery_organization",resObj.obj_delivery_organization)
            if ((!vm.$myConstants.isEmpty(resObj.obj_delivery_user))){
              if (resObj.delivery_relative_receiving == 1 || (resObj.delivery_relative_receiving == 0 && resObj.receive_sender == 0)){
                if ((!vm.$myConstants.isEmpty(resObj.obj_delivery_user.obj_customer_profile))) {
                  vm.objectLoadData.delivery_user_text = (!vm.$myConstants.isEmpty(resObj.obj_delivery_user.obj_customer_profile.full_name)) ? resObj.obj_delivery_user.obj_customer_profile.full_name:'';
                  vm.objectLoadData.delivery_user_phone_text = (!vm.$myConstants.isEmpty(resObj.obj_delivery_user.obj_customer_profile.phone_number)) ? resObj.obj_delivery_user.obj_customer_profile.phone_number.replace('+84', '0'):'';
                }
              }else if (resObj.delivery_relative_receiving == 2 || (resObj.delivery_relative_receiving == 0 && resObj.receive_sender == 1)){
                vm.objectLoadData.delivery_user_text = (!vm.$myConstants.isEmpty(resObj.obj_delivery_user.full_name)) ? resObj.obj_delivery_user.full_name:'';
                vm.objectLoadData.delivery_user_phone_text = (!vm.$myConstants.isEmpty(resObj.obj_delivery_user.phone_number)) ? resObj.obj_delivery_user.phone_number.replace('+84', '0'):'';
                if (resObj.obj_delivery_user.organization_account){
                  if (resObj.obj_delivery_user.organization_account.organization){
                    vm.objectLoadData.delivery_organization_text = (resObj.obj_delivery_user.organization_account.organization.name) ? resObj.obj_delivery_user.organization_account.organization.name:'';//tên đơn vị
                  }
                }
              }
            }
            if ((!vm.$myConstants.isEmpty(resObj.delivery_method))){
              if (resObj.delivery_method.toString() == '0'){
                vm.objectLoadData.delivery_method_text = 'Tại trung tâm bảo hành';
              }else if (resObj.delivery_method.toString() == '1'){
                vm.objectLoadData.delivery_method_text = 'Giao tận nơi người nhận';
                var name_province = (!vm.$myConstants.isEmpty(resObj.province)) ? resObj.province.name:'';
                var name_district = (!vm.$myConstants.isEmpty(resObj.district)) ? resObj.district.name:'';
                var name_ward = (!vm.$myConstants.isEmpty(resObj.ward)) ? resObj.ward.name:'';
                var delivery_apartment_number = (!vm.$myConstants.isEmpty(resObj.delivery_apartment_number)) ? resObj.delivery_apartment_number.trim():'';
                if (
                    !vm.$myConstants.isEmpty(name_province)
                    && !vm.$myConstants.isEmpty(name_district)
                    && !vm.$myConstants.isEmpty(name_ward)
                    && !vm.$myConstants.isEmpty(delivery_apartment_number)
                ){
                  vm.objectLoadData.delivery_address_full = delivery_apartment_number+', '+name_ward+', '+name_district+', '+name_province;
                }
              }
            }

            if (resObj.obj_modifier){
              vm.objectLoadData.modifier_name = (resObj.obj_modifier.full_name) ? resObj.obj_modifier.full_name:'';//tên người cập nhật
            }
            if (resObj.obj_creator_organization){
              vm.objectLoadData.organization_modifier_name = (resObj.obj_creator_organization.name) ? resObj.obj_creator_organization.name:'';//tên đơn vị cập nhật
            }
            //ẩn column danh sách sp
            vm.hideColumnListProductSerial(false,this.objectLoadData.process_status);
            if (this.objectLoadData.process_status < 2 ) {
              console.log('1');
            }else {
              var total_cost = vm.get_total_cost(resObj.arr_warranty_repair_product_serial_number_aggregate);
              var total_cost_str = vm.$myConstants.numberFormat(total_cost, 0, '', '.');
              var colspan_total = 5;
              if(!vm.$myConstants.checkRoleGroup('warranty_repair', 'view')) {
                //ẩn colum detail thì - 1 cột
                colspan_total--;
              }
              vm.list_product_serial.rowFooterProductSerial = [
                [
                  { name: 'total_cost', type: "Text", value: 'Tổng chi phí', colspan:colspan_total,style:'text-align:right' },
                  { name: 'delivery_return_appointment_day', type: "Text", value: ''+total_cost_str, colspan:1,style:'text-align:right' },
                  { name: 'delivery_return_appointment_day', type: "Text", value: 'VNĐ', colspan:1,style:'text-align:center' },
                ]
              ];

            }

            //default dữ liệu thông tin giao trả
            //if (vm.objectLoadData.process_status > vm.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_RECEIVED && vm.objectLoadData.process_status < vm.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.COMPLETE ){
            switch(vm.objectLoadData.process_status) {
              case vm.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.SEND_REQUIRE:
                vm.disable_send_require = true;
                break;
              case vm.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_RECEIVED:
                  vm.disable_waiting_receive = true;
                break;
              default:
                // code block
            }
            //vm.objectLoadData.receive_user_text = (!vm.$myConstants.isEmpty(resObj.obj_receive_user.obj_customer_profile.full_name)) ? resObj.obj_receive_user.obj_customer_profile.full_name : '';
            //vm.objectLoadData.receive_user_phone_text = (!vm.$myConstants.isEmpty(resObj.obj_receive_user.obj_customer_profile.phone_number)) ? resObj.obj_receive_user.obj_customer_profile.phone_number.replace('+84', '0') : '';
            var itemDataCustomer = {
              id:(!vm.$myConstants.isEmpty(resObj.receive_user_id)) ? resObj.receive_user_id:'',
              group_title:vm.objectLoadData.receive_user_phone_text+" - "+vm.objectLoadData.receive_user_text,
              phone_number:vm.objectLoadData.receive_user_phone_text,
              full_name:vm.objectLoadData.receive_user_text,
            }
            if (this.objectDataWarrantyRepair.is_fix_send_request == 1){
              //Nếu là gửi yêu cầu thì load thông tin liên hệ
              vm.objectDataWarrantyRepair.receive_contact_info_text = vm.convert_info_contact(resObj.receive_contact_info);
            }
            /*if (vm.objectLoadData.process_status == vm.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.SEND_REQUIRE || vm.objectLoadData.process_status == vm.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_RECEIVED){
              //Nếu là gửi yêu cầu thì load thông tin liên hệ
              vm.objectDataWarrantyRepair.receive_contact_info_text = vm.convert_info_contact(resObj.receive_contact_info);
            }*/
              vm.objectDataWarrantyRepair.request_submission_date =  (!vm.$myConstants.isEmpty(resObj.created_date)) ? moment.tz(resObj.created_date, vm.$myConstants.timeZone()).format('DD/MM/YYYY'):'';
              vm.objectDataWarrantyRepair.process_status = vm.objectLoadData.process_status;
              vm.objectDataWarrantyRepair.receive_note = (!vm.$myConstants.isEmpty(resObj.receive_note)) ? resObj.receive_note:'';
              vm.objectDataWarrantyRepair.note_delivery = (!vm.$myConstants.isEmpty(resObj.note_delivery)) ? resObj.note_delivery:'';
              vm.objectDataWarrantyRepair.receive_method = resObj.receive_method.toString();
              vm.objectDataWarrantyRepair.receive_sender = resObj.receive_sender;
              vm.objectDataWarrantyRepair.receive_day_reception = vm.objectLoadData.receive_day_reception_text;
              vm.objectDataWarrantyRepair.receive_user_id = itemDataCustomer.id;
              if (resObj.receive_sender == 1){
                vm.objectDataWarrantyRepair.receive_organization_id = resObj.receive_organization_id;
              }
              vm.nameReceiveUsers = itemDataCustomer.full_name;
              vm.selectedReceiveUsers = itemDataCustomer;
              vm.selectedReceiveUsers.group_title = itemDataCustomer.phone_number;
              /*var test = 1;
              if (test == 1){
                return false;
              }*/
              if (resObj.receive_method.toString() == '0') {
                vm.objectDataWarrantyRepair.delivery_user_id = (!vm.$myConstants.isEmpty(resObj.delivery_user_id)) ? resObj.delivery_user_id:'';
                vm.objectDataWarrantyRepair.delivery_return_appointment_day = vm.objectLoadData.delivery_return_appointment_day_text;
                vm.objectDataWarrantyRepair.delivery_relative_receiving = resObj.delivery_relative_receiving;
                if (resObj.delivery_relative_receiving == 2){
                  vm.objectDataWarrantyRepair.delivery_organization_id = resObj.delivery_organization_id
                }
                vm.selectedDeliveryUser = vm.objectLoadData.delivery_user_phone_text;
                vm.nameDeliveryUser = vm.objectLoadData.delivery_user_text;
                vm.objectDataWarrantyRepair.delivery_method = (!this.$myConstants.isEmpty(resObj.delivery_method)) ? resObj.delivery_method.toString():null;
                if (vm.objectDataWarrantyRepair.delivery_method == '1'){
                  //load quận huyện xã phường
                  var delivery_province_id = (!vm.$myConstants.isEmpty(resObj.province)) ? resObj.province.id:'';
                  var delivery_district_id = (!vm.$myConstants.isEmpty(resObj.district)) ? resObj.district.id:'';
                  var delivery_ward_id = (!vm.$myConstants.isEmpty(resObj.ward)) ? resObj.ward.id:'';
                  var data_address = {
                    delivery_province_id:delivery_province_id,
                    delivery_district_id:delivery_district_id,
                    delivery_ward_id:delivery_ward_id,
                    delivery_apartment_number:(!vm.$myConstants.isEmpty(resObj.delivery_apartment_number)) ? resObj.delivery_apartment_number.trim():'',
                  };
                  vm.load_address_delivery(data_address);
                }
              }
            //}


          }
        }).catch(async (err) => {
          console.log("errerrerrerrerrerrerrerr:",err)
          vm.$toast.add({
            severity: 'error',
            summary: 'Thông báo',
            detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
            life: 3000
          });
        });

        var variables_product_serial_number = {
          where_key: {
            warranty_repair_id: {_eq: warranty_repair_id},
            status: {_eq: 1}
          },
          orderBy: {"id": "asc"}
        }

        //Lấy ds sản phẩm
        DataServices.getList('warranty_repair_product_serial_number', {"variables": JSON.stringify(variables_product_serial_number)}).then(async (data) => {
          var list = data[Object.keys(data)];
          //Lấy list id cũ để kiểm tra update
          var list_data = [];
          for (var i = 0; i < list.length; i++) {
            var serial_number_lookup = list[i].product_serial_number.serial_number;
            var dataRes = await this.$coreService.getSerialWarrantyActivationBySerial(serial_number_lookup);
            var process_status_warranty_repair = (!this.$myConstants.isEmpty(list[i].obj_warranty_repair)) ? list[i].obj_warranty_repair.process_status:null;

            var file_image = [];
            if (list[i].list_img_status_product){
              var list_img_status_product = JSON.parse(list[i].list_img_status_product);
              for (var j=0;j<list_img_status_product.length;j++){
                var itemDataImg = list_img_status_product[j];
                itemDataImg.src = itemDataImg.url;
                itemDataImg.old = true;
                file_image.push(itemDataImg)
              }
            }
            var param_convert = {
              mode:'view',
              type_service:(!vm.$myConstants.isEmpty(list[i].type_service)) ? list[i].type_service:null,
              maintenance_period:(!vm.$myConstants.isEmpty(list[i].maintenance_period)) ? list[i].maintenance_period:null,
              desc_status_product:(!vm.$myConstants.isEmpty(list[i].desc_status_product)) ? list[i].desc_status_product:'',
              list_img_status_product:file_image,
              objectDataSerial:dataRes
            };
            switch(process_status_warranty_repair) {
              case this.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_IMPLEMENTATION:
              case this.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_DELIVERY:
              case this.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.COMPLETE:
                param_convert.mode = 'detail';
                break;
              case this.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.SEND_REQUIRE:
                param_convert.mode = 'detail_receive';
                break;
              default:
                param_convert.mode = 'edit';
                // code block
            }
            //var data_convert = this.convertObjectDataSerial(param_convert);
            var data_convert = this.$coreService.convertObjectDataSerial(param_convert);
            data_convert.warranty_repair_product_serial_number_id = (!vm.$myConstants.isEmpty(list[i].id)) ? list[i].id:null;
            var service_total_price_payment = (!vm.$myConstants.isEmpty(list[i].service_total_price_payment) ? vm.$myConstants.numberFormat(list[i].service_total_price_payment, 0, '', '.'):0);
            //Nếu hỏi ý kiến khách hàng từ chối  thì ko hiển thị tiền
            if (list[i].check_result == 2 && list[i].check_is_customer_reply == 0 ){
              service_total_price_payment = 0;
            }
            var dataChange = {
              id:data_convert.id,
              serial_number:data_convert.object_info_product.serial_number,
              model_code:data_convert.object_info_product.model_code,
              product_name:data_convert.object_info_product.product_name,
              type_service:data_convert.type_service,
              desc_status_product:data_convert.desc_status_product,
              list_img_status_product:data_convert.list_img_status_product,
              process_status:(!vm.$myConstants.isEmpty(list[i].process_status)) ? list[i].process_status.toString():null,
              process_status_recieve:(!vm.$myConstants.isEmpty(list[i].process_status)) ? parseFloat(list[i].process_status):null,
              service_total_price_payment:service_total_price_payment,
              serial_number_info:'',
              detail_product_serial:'<a href="#">Xem</a>',
              object_data:data_convert
            };
            if (parseFloat(list[i].process_status) == 0){//Nếu danh sách sản phẩm còn trạng thái chờ thực hiện thì diable nút chờ giao trả
              vm.disable_btn_waiting_delivery = true;
            }
            list_data.push(dataChange);
          }
          console.log("list_datalist_datalist_datalist_data:",list_data)
          vm.list_product_serial.listData = list_data;
          vm.list_product_serial.componentKey++;
        }).catch(async () => {
          vm.list_product_serial.listData = [];
        });

      }else {
        if (!vm.$myConstants.checkRoleGroup('warranty_repair', 'add')){
          vm.display_page = false;
        }
        this.display_step([1]);
        vm.status_active = vm.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_RECEIVED;
        this.key_process++;//refesh lại component
        //Ẩn column
        vm.hideColumnListProductSerial(true);
        console.log("this.$route.query.id_maintenance:",this.$route.query.id_maintenance)
        var id_maintenance = this.$route.query.id_maintenance;
        if (!vm.$myConstants.isEmpty(id_maintenance)){
          //Tồn tại bào trì định kỳ
          vm.load_maintenance();
        }else {
          //thêm mới
          vm.list_product_serial.listData = [];
          vm.list_product_serial.componentKey++;
        }

      }
      setTimeout(function(){ vm.$store.commit('setLoading', false);}, 1000);
    },
    convert_info_contact(receive_contact_info){
      var vm =this;
      var receive_contact_info_text = "";
      var receive_contact_info_obj = (!vm.$myConstants.isEmpty(receive_contact_info)) ? JSON.parse(receive_contact_info):null;
      if (!vm.$myConstants.isEmpty(receive_contact_info_obj)){
        var name_phone ="";
        name_phone += (!vm.$myConstants.isEmpty(receive_contact_info_obj.full_name)) ? receive_contact_info_obj.full_name:"";
        name_phone += (!vm.$myConstants.isEmpty(receive_contact_info_obj.phone_number)) ? "-"+receive_contact_info_obj.phone_number.replace('+84', '0'):"";
        var company_name = (!vm.$myConstants.isEmpty(receive_contact_info_obj.company_name)) ? "\n"+receive_contact_info_obj.company_name:"";
        var address_support = "";
        if (!vm.$myConstants.isEmpty(receive_contact_info_obj.apartment_number)
            && !vm.$myConstants.isEmpty(receive_contact_info_obj.obj_province)
            && !vm.$myConstants.isEmpty(receive_contact_info_obj.obj_district)
            && !vm.$myConstants.isEmpty(receive_contact_info_obj.obj_ward)
        ){
          address_support +="\nĐịa chỉ:";
          address_support += receive_contact_info_obj.apartment_number+", ";
          address_support += (!vm.$myConstants.isEmpty(receive_contact_info_obj.obj_ward.name)) ? receive_contact_info_obj.obj_ward.name+", ":'';
          address_support += (!vm.$myConstants.isEmpty(receive_contact_info_obj.obj_district.name)) ? receive_contact_info_obj.obj_district.name+", ":'';
          address_support += (!vm.$myConstants.isEmpty(receive_contact_info_obj.obj_province.name)) ? receive_contact_info_obj.obj_province.name+", ":'';
        }
        var note_contact = (!vm.$myConstants.isEmpty(receive_contact_info_obj.note)) ? "\n"+receive_contact_info_obj.note:'';
        receive_contact_info_text = name_phone+company_name+address_support+note_contact;
      }
      return receive_contact_info_text;
    },
    async list_statsus_process(warranty_repair_id){
      var variables_warranty_repair_process = {
        where_key: {
          warranty_repair_id: {_eq: warranty_repair_id}
        },
        orderBy: {"id": "desc"}
      }
      var list_process = await DataServices.getListData('warranty_repair_process', {"variables": JSON.stringify(variables_warranty_repair_process)});
      var list_status = [];
      for (var i=0;i<list_process.length;i++){
        list_status.push(list_process[i].process_status);
      }
      return list_status;
    },
    display_step(arr_hide){
      var listRemoveIndex = [];
      for (var g=0;g<this.list_process.length;g++){
        var key_step = parseFloat(this.list_process[g].key_step);
        if (arr_hide.indexOf(key_step) >-1 ){
          listRemoveIndex.push(g);
        }
      }
      for (var i = listRemoveIndex.length -1; i >= 0; i--){//xóa ngược để ko thay đổi index của array
        this.list_process.splice(listRemoveIndex[i], 1);
      }
    },
    load_maintenance(){
      var vm = this;
      var id_maintenance = this.$route.query.id_maintenance;
      var whereObject = {
        id: {'_eq': id_maintenance},
      }
      DataServices.getObjectData('maintenance', whereObject, {id: 'desc'}).then(async (resObj) => {
        if (resObj){
          var serial_number = (!vm.$myConstants.isEmpty(resObj.product_serial_number)) ? resObj.product_serial_number.serial_number:'';
          var serial_user_id = (!vm.$myConstants.isEmpty(resObj.serial_user_id)) ? resObj.serial_user_id:null;
          var checkSerialNumber = await this.$coreService.getSerialWarrantyActivationBySerial(serial_number);
          if (checkSerialNumber){
            var param_convert = {
              mode:'add',
              type_service:vm.$dataCommon.WARRANTY_REPAIR.TYPE_SERVICE.MAINTENANCE,
              maintenance_period:resObj.id,
              desc_status_product:'',
              list_img_status_product:[],
              objectDataSerial:checkSerialNumber
            };
            //var data_convert = this.convertObjectDataSerial(param_convert);
            var data_convert = this.$coreService.convertObjectDataSerial(param_convert);
            var params = data_convert;
            var dataChange = {
              id:params.id,
              serial_number:params.object_info_product.serial_number,
              model_code:params.object_info_product.model_code,
              product_name:params.object_info_product.product_name,
              type_service: params.type_service,//default bảo trì định kỳ
              maintenance_period: params.maintenance_period,//default bảo trì định kỳ
              desc_status_product:params.desc_status_product,
              list_img_status_product:params.list_img_status_product,
              process_status:null,
              process_status_recieve:null,
              service_total_price_payment:0,
              serial_number_info:'',
              detail_product_serial:'<a href="#">Xem</a>',
              object_data:params
            };
            vm.list_product_serial.listData.unshift(dataChange);
            vm.list_product_serial.componentKey++;
          }
          //set defailt người gửi
          if (!vm.$myConstants.isEmpty(serial_user_id)){
            vm.defaultCustomer(serial_user_id,'add_receive');
          }
        }
      }).catch(async () => {
        vm.$toast.add({
          severity: 'error',
          summary: 'Thông báo',
          detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
          life: 3000
        });
      });
    },
    get_total_cost(arr_warranty_repair_product_serial_number_aggregate){
      var arr_data = arr_warranty_repair_product_serial_number_aggregate
      var total_cost = 0;
      if (!this.$myConstants.isEmpty(arr_data)) {
        if (!this.$myConstants.isEmpty(arr_data.aggregate)) {
          if (!this.$myConstants.isEmpty(arr_data.aggregate.sum)) {
            if (!this.$myConstants.isEmpty(arr_data.aggregate.sum.service_total_price_payment)) {
              total_cost = parseFloat(arr_data.aggregate.sum.service_total_price_payment);
            }
          }
        }
      }
      return total_cost;
    },
    async hideColumnListProductSerial(is_create_receive,process_status=null) {
      var that = this;
      if (is_create_receive == true){
        //ẩn
        this.list_product_serial.columnsDisplays.push('service_total_price_payment');
        this.list_product_serial.columnsDisplays.push('process_status');
        this.list_product_serial.columnsDisplays.push('process_status_recieve');
      }else {
        switch(process_status) {
          case this.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.SEND_REQUIRE:
            this.list_product_serial.columnsDisplays.push('service_total_price_payment');
            this.list_product_serial.columnsDisplays.push('process_status');
            this.list_product_serial.columnsDisplays.push('type_service');
            break;
          case this.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_RECEIVED:
            this.list_product_serial.columnsDisplays.push('service_total_price_payment');
            this.list_product_serial.columnsDisplays.push('process_status');
            break;
          default:
            this.list_product_serial.columnsDisplays.push('process_status_recieve');
            if(!that.$myConstants.checkRoleGroup('warranty_repair', 'view')) {
              this.list_product_serial.columnsDisplays.push('detail_product_serial');
            }
            // code block
        }
      }

    },
    async getData() {
      var variables = {
        where_key: {
          id: {'_eq': this.roleID}
        }
      }
      var data = await DataServices.getList(this.modelName, {
        "variables": JSON.stringify(variables),
        "fields": "id name description is_management_lower_level status role_permission(where: {status: {_eq: 1} }) { id role_id permission_id permission { type }}"
      });
      var list = data[Object.keys(data)];
      if (list != null && Object.keys(list).length) {
        this.labelName = 'Lưu';
        this.titleModel = 'Chỉnh sửa quyền truy cập';
        var model = list[0];
        this.modelPermissionData = model;
        this.name = model.name;
        this.description = model.description;
        this.is_management_lower_level = model.is_management_lower_level;
        this.status = model.status;
        var modelData = (model.role_permission != undefined && model.role_permission != null) ? model.role_permission : [];
        if (modelData) {
          for (let index = 0; index < modelData.length; index++) {
            const item = modelData[index];
            if (item.permission != undefined & item.permission != null && item.permission.type != undefined && item.permission.type != '') {
              if (item.permission.type == 'web') this.permissonAllWeb[item.permission_id] = true;
              else if (item.permission.type == 'mobile') this.permissonAllMobile[item.permission_id] = true;
            }
          }
        }
      }
      this.componentKey = Math.random() * 1020;
    },
    backList() {
      this.$router.push({path: '/admin/warranty-repair'});
    },
    async clickChange($event) {
      this.activeIndex = parseInt($event.tab.$vnode.data.key);
      await this.getData();
    },
    changeChecked(payload) {
      if (payload.type == 'web') {
        this.permissonAllWeb = payload.lists;
      } else if (payload.type == 'mobile') {
        this.permissonAllMobile = payload.lists;
      }
    },
    async checkName() {
      this.name = this.name.trim();
      if (this.name !== undefined && this.name !== "") {
        var where = {name: {'_ilike': this.name}}
        if (this.modelPermissionData != null) where = Object.assign(where, {id: {'_neq': this.modelPermissionData.id}})
        var data = await DataServices.getList(this.modelName, {
          "fields": "id",
          "variables": JSON.stringify({where_key: where})
        });
        return data && data[Object.keys(data)].length > 0
      }
    },
    async processPermission() {
      var permissionName = 'role_permission';
      var count = 0;
      // xoá tất cả các quyền đã thêm trước đó
      if (this.modelPermissionData && this.roleID > 0) {
        var variables = {
          where_key: {
            role_id: {'_eq': this.roleID}
          }
        }
        await DataServices.deleteData(permissionName, {"variables": JSON.stringify(variables)});
      }
      var params = [];
      var roleIDTemp = this.roleID;
      var ordering = 0;
      var that = this;
      if (this.permissonAllWeb && this.permissonAllWeb.length) {
        this.permissonAllWeb.forEach(function (value, index) {
          ordering++;
          if (value) {
            params.push({
              role_id: roleIDTemp,
              permission_id: index,
              ordering: ordering,
              created_date: that.$myConstants.currentDate(),
              modified_date: that.$myConstants.currentDate(),
              status: 1
            });
          }
        });
      }
      if (this.permissonAllMobile && this.permissonAllMobile.length) {
        this.permissonAllMobile.forEach(function (value, index) {
          ordering++;
          if (value) {
            params.push({
              role_id: roleIDTemp,
              permission_id: index,
              ordering: ordering,
              created_date: that.$myConstants.currentDate(),
              modified_date: that.$myConstants.currentDate(),
              status: 1
            });
          }
        });
      }
      if (params && params.length) {
        var dataInsert = await DataServices.insertData(permissionName, {"variables": JSON.stringify({objects: params})});
        if (dataInsert && Object.keys(dataInsert).length) count = 1;
      } else count = 1;

      if (count > 0) {
        this.$store.commit('setLoading', false);
        this.$toast.add({severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000})
        setTimeout(() => {
          this.$router.push({path: '/admin/role'});
        }, 500);
      }
    },
    async getCodeNext() {
      var YY = moment.tz((new Date().toUTCString()), this.$myConstants.timeZone()).format('YY');
      var codeLeft = "HK"+YY;
      var data = await DataServices.getObjectData('warranty_repair', {code: {_like: "%"+codeLeft+"%"} }, {id: 'desc'});
      if (!this.$myConstants.isEmpty(data)) {
        var codeLast = data.code;
        var codeRightLast = codeLast.substring((codeLast.length - 6));//Cắt lấy 6 ký tự cuối cùng
        var codeRightTmp = (parseInt(codeRightLast) + 1).toString();
        return codeLeft + codeRightTmp.padStart(6, '0');
      }
      return codeLeft+'000001';
    },
    async validationData() {
      //var vm =this;
      this.validationErrors = {};
      if (this.list_product_serial.listData.length < 1){
        this.validationErrors['list_product_serial'] = 'Vui lòng thêm sản phẩm vào danh sách';
      }
      if (this.$myConstants.isEmpty(this.objectDataWarrantyRepair.receive_day_reception)) {
        this.validationErrors['receive_day_reception'] = 'Nhập ngày tiếp nhận';
      }else {
        var check_receive_day_reception = new Date(moment(this.objectDataWarrantyRepair.receive_day_reception, "DD/MM/YYYY"));
        if (isNaN(check_receive_day_reception.getTime())) {
          this.validationErrors['receive_day_reception'] = 'Ngày tiếp nhận không đúng định dạng.';
        }
      }
      // khách hàng
      if (this.$myConstants.isEmpty(this.objectDataWarrantyRepair.receive_user_id)){
        this.validationErrors['receive_user_id'] = 'Nhập thông tin người gửi';
      }
      /*var receive_sender = this.objectDataWarrantyRepair.receive_sender;
      switch(receive_sender) {
        case 0:
          // khách hàng
          if (this.$myConstants.isEmpty(this.objectDataWarrantyRepair.receive_user_id)){
            this.validationErrors['receive_user_id'] = 'Nhập thông tin người gửi';
          }
          break;
        case 1:
            // nhân viên đại lý
            if (this.$myConstants.isEmpty(this.objectDataWarrantyRepair.receive_organization_id)){
              this.validationErrors['receive_organization_id'] = 'Chọn đơn vị';
            }
          break;
        default:
          // code block
      }*/
      if (this.objectDataWarrantyRepair.receive_method == '0'){
        if (this.$myConstants.isEmpty(this.objectDataWarrantyRepair.delivery_return_appointment_day)) {
          this.validationErrors['delivery_return_appointment_day'] = 'Nhập ngày hẹn trả';
        }else {
          var check_delivery_return_appointment_day = new Date(moment(this.objectDataWarrantyRepair.delivery_return_appointment_day, "DD/MM/YYYY"));
          if (isNaN(check_delivery_return_appointment_day.getTime())) {
            this.validationErrors['delivery_return_appointment_day'] = 'Ngày hẹn trả không đúng định dạng.';
          }else {

            var receive_day_reception_check = moment(this.objectDataWarrantyRepair.receive_day_reception, "DD/MM/YYYY").format("YYYYMMDD");
            var delivery_return_appointment_day_check = moment(this.objectDataWarrantyRepair.delivery_return_appointment_day, "DD/MM/YYYY").format("YYYYMMDD");
            if (parseFloat(delivery_return_appointment_day_check) < parseFloat(receive_day_reception_check)){
              this.validationErrors['delivery_return_appointment_day'] = 'Ngày hẹn trả nhỏ hơn ngày tiếp nhận.';
            }
          }

        }
        //delivery_organization_id
        var delivery_relative_receiving = this.objectDataWarrantyRepair.delivery_relative_receiving;
        if (this.$myConstants.isEmpty(delivery_relative_receiving)){
          this.validationErrors['receive_sender'] = 'Chọn đối tượng nhận';
        }
        if (this.$myConstants.isEmpty(this.objectDataWarrantyRepair.delivery_method)){
          this.validationErrors['delivery_method'] = 'Chọn hình thức giao trả';
        }
        switch(delivery_relative_receiving) {
          case 0:
            // Người gửi
            break;
          case 1:
          case 2:
            // Khách hàng
            if (this.$myConstants.isEmpty(this.objectDataWarrantyRepair.delivery_user_id)){
              this.validationErrors['delivery_user_id'] = 'Nhập thông tin người nhận';
            }
            // nhân viên đại lý
            /*if (this.$myConstants.isEmpty(this.objectDataWarrantyRepair.delivery_organization_id)){
              this.validationErrors['delivery_organization_id'] = 'Chọn đơn vị';
            }*/
            break;
          default:
            // code block
        }

        //nếu giao tận nơi người nhận thì bắt buộc nhập địa chỉ
        if (this.objectDataWarrantyRepair.delivery_method == '1'){
          if (
              this.$myConstants.isEmpty(this.objectDataWarrantyRepair.delivery_province_id)
              || this.$myConstants.isEmpty(this.objectDataWarrantyRepair.delivery_district_id)
              || this.$myConstants.isEmpty(this.objectDataWarrantyRepair.delivery_ward_id)
              || this.$myConstants.isEmpty(this.objectDataWarrantyRepair.delivery_apartment_number.trim())
          ){
            this.validationErrors['delivery_address'] = 'Nhập đầy đủ địa chỉ người nhận';
          }
        }
      }
      if (!(Object.entries(this.validationErrors).length === 0)) {
        //Nếu tồn tại lỗi thì force để load validator mượt
        this.$forceUpdate();
      }
    },
    async validationDataDelivery() {
      //var vm =this;
      this.validationErrors = {};
      if (this.$myConstants.isEmpty(this.objectDataWarrantyRepair.delivery_return_appointment_day)) {
          this.validationErrors['delivery_return_appointment_day'] = 'Nhập ngày hẹn trả';
        }else {
          var check_delivery_return_appointment_day = new Date(moment(this.objectDataWarrantyRepair.delivery_return_appointment_day, "DD/MM/YYYY"));
          if (isNaN(check_delivery_return_appointment_day.getTime())) {
            this.validationErrors['delivery_return_appointment_day'] = 'Ngày hẹn trả không đúng định dạng.';
          }else {

            var receive_day_reception_check = moment(this.objectDataWarrantyRepair.receive_day_reception, "DD/MM/YYYY").format("YYYYMMDD");
            var delivery_return_appointment_day_check = moment(this.objectDataWarrantyRepair.delivery_return_appointment_day, "DD/MM/YYYY").format("YYYYMMDD");
            if (parseFloat(delivery_return_appointment_day_check) < parseFloat(receive_day_reception_check)){
              this.validationErrors['delivery_return_appointment_day'] = 'Ngày hẹn trả nhỏ hơn ngày tiếp nhận.';
            }
          }

        }
        //delivery_organization_id
        var delivery_relative_receiving = this.objectDataWarrantyRepair.delivery_relative_receiving;
        switch(delivery_relative_receiving) {
          case 0:
            // Người gửi
            break;
          case 1:
          case 2:
            // Khách hàng
            if (this.$myConstants.isEmpty(this.objectDataWarrantyRepair.delivery_user_id)){
              this.validationErrors['delivery_user_id'] = 'Nhập thông tin người nhận';
            }
            // nhân viên đại lý
            /*if (this.$myConstants.isEmpty(this.objectDataWarrantyRepair.delivery_organization_id)){
              this.validationErrors['delivery_organization_id'] = 'Chọn đơn vị';
            }*/
            break;
          default:
            // code block
        }

        //nếu giao tận nơi người nhận thì bắt buộc nhập địa chỉ
        if (this.objectDataWarrantyRepair.delivery_method == '1'){
          if (
              this.$myConstants.isEmpty(this.objectDataWarrantyRepair.delivery_province_id)
              || this.$myConstants.isEmpty(this.objectDataWarrantyRepair.delivery_district_id)
              || this.$myConstants.isEmpty(this.objectDataWarrantyRepair.delivery_ward_id)
              || this.$myConstants.isEmpty(this.objectDataWarrantyRepair.delivery_apartment_number.trim())
          ){
            this.validationErrors['delivery_address'] = 'Nhập đầy đủ địa chỉ người nhận';
          }
        }
      if (!(Object.entries(this.validationErrors).length === 0)) {
        //Nếu tồn tại lỗi thì force để load validator mượt
        this.$forceUpdate();
      }
    },
    convertDate(date_convert) {
      var dateNow = new Date();
      const [d, M, y] = date_convert.match(/\d+/g);
      var changeDate = new Date(y, M-1, d, dateNow.getHours(), dateNow.getMinutes(), dateNow.getSeconds());
      var receive_day_reception = changeDate.toUTCString();
      return receive_day_reception;
    },
    async update_status_wr(status_update,is_reload=0) {
      var vm = this;
      /*var organization = this.$myConstants.organizationUserLogin();
      var creator_organization_id = (!this.$myConstants.isEmpty(organization.id)) ? organization.id:null;*/
      var list_product_serial = vm.list_product_serial.listData;
      //console.log("list_product_serial:",list_product_serial)
      if (parseFloat(status_update) == 3) {
        //Kiểm tra trạng thái của sp phẩm != chờ thự hiện chưa
        if (list_product_serial.length < 1) {
          return false;
        }
        for (var i = 0; i < list_product_serial.length; i++) {
          if (parseFloat(list_product_serial[i].process_status) == 0) {
            return false;
          }
        }
      }
      var warranty_repair_id = this.$route.params.id;
      var whereObject = {
        id: {'_eq': warranty_repair_id}
      }
      var resObj = await DataServices.getObjectData('warranty_repair_detail', whereObject, {id: 'desc'});
      if (status_update == this.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_RECEIVED &&  resObj.process_status != this.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.SEND_REQUIRE ){
        this.toastErrCommon();
        return false;
      }
      else if (status_update == this.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_IMPLEMENTATION &&  resObj.process_status != this.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_RECEIVED ){
        this.toastErrCommon();
        return false
      }
      else if (status_update == this.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_DELIVERY &&  resObj.process_status != this.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_IMPLEMENTATION ){
        this.toastErrCommon();
        return false
      }else if (status_update == this.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.COMPLETE &&  resObj.process_status != this.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_DELIVERY){
        this.toastErrCommon();
        return false;
      }
     /* var test =1;
      if (test == 1){
        return false;
      }*/
      var params = {
        process_status: status_update,
        modifier_id: this.$store.getters.fullname.id,
        modified_date: this.$myConstants.currentDate(),
      }
      var is_agree_receive = 0;
      var queryUpsertProduct = ``;
      var list_upsert_product = [];
      var key_action = 0;//1.Chờ tiếp nhận, 2.Chờ thực hiện
      switch(status_update) {
        case this.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_IMPLEMENTATION:
        case this.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_RECEIVED:
          for (var s=0;s<list_product_serial.length;s++){
            if (vm.$myConstants.isEmpty(list_product_serial[s].process_status_recieve) || list_product_serial[s].process_status_recieve == vm.$dataCommon.WARRANTY_REPAIR.PRODUCT_STATUS.SEND_REQUIRE){
              this.$toast.add({
                severity: 'error',
                summary: 'Thông báo',
                detail: 'Vui lòng chọn trạng thái thực hiện.',
                life: 3000
              });
              return ;
            }
            if (status_update == this.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_IMPLEMENTATION){
              if (this.$myConstants.isEmpty(list_product_serial[s].type_service) && list_product_serial[s].process_status_recieve == vm.$dataCommon.WARRANTY_REPAIR.PRODUCT_STATUS.AGREE_RECEIVE){
                this.$toast.add({
                  severity: 'error',
                  summary: 'Thông báo',
                  detail: 'Vui lòng cập nhật loại dịch vụ.',
                  life: 3000
                });
                return ;
              }
            }
          }
          if (status_update == this.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_IMPLEMENTATION) {
            await this.validationData();
            if (!(Object.entries(this.validationErrors).length === 0)) {
              return false;
            }
          }
          // Kiểm tra đã chọn trạng thái thực hiện chưa
            for (var k=0;k<list_product_serial.length;k++){
              if (list_product_serial[k].process_status_recieve == vm.$dataCommon.WARRANTY_REPAIR.PRODUCT_STATUS.AGREE_RECEIVE){
                is_agree_receive = 1;
              }
             // console.log("list_product_serial[k].warranty_repair_product_serial_number_id:",list_product_serial[k].warranty_repair_product_serial_number_id)
              if (!this.$myConstants.isEmpty(list_product_serial[k].object_data.warranty_repair_product_serial_number_id)){
                var itemDataProduct = {
                  id:list_product_serial[k].object_data.warranty_repair_product_serial_number_id,
                  process_status:list_product_serial[k].process_status_recieve,
                  type_service:list_product_serial[k].type_service,
                  modifier_id:this.$store.getters.fullname.id,
                  modified_date:this.$myConstants.currentDate()
                };
                if (status_update == this.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_IMPLEMENTATION){
                  //nếu đồng ý tiếp nhận gán  trạng thái chờ thực hiện
                  itemDataProduct.process_status = (list_product_serial[k].process_status_recieve == vm.$dataCommon.WARRANTY_REPAIR.PRODUCT_STATUS.AGREE_RECEIVE) ? vm.$dataCommon.WARRANTY_REPAIR.PRODUCT_STATUS.WAITING_IMPLEMENTATION:list_product_serial[k].process_status_recieve;
                  var list_img_status_product = list_product_serial[k].list_img_status_product;
                  var list_image_upload = list_img_status_product;
                  for (var h = 0; h < list_img_status_product.length; h++) {
                    if (this.$myConstants.isEmpty(list_img_status_product[h].old)){
                      var obj_image = await this.$coreService.uploadOneImages(list_img_status_product[h]);
                      list_image_upload[h] = obj_image;
                    }
                  }
                  console.log("list_image_uploadlist_image_uploadlist_image_uploa:",list_image_upload)
                  itemDataProduct.list_img_status_product = (list_image_upload.length > 0) ? JSON.stringify(list_image_upload):null;
                }else {
                  itemDataProduct.list_img_status_product = (list_product_serial[k].list_img_status_product && list_product_serial[k].list_img_status_product.length > 0) ? JSON.stringify(list_product_serial[k].list_img_status_product):null;
                }
                list_upsert_product.push(itemDataProduct);
              }
            }
            if (status_update == this.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_IMPLEMENTATION) {
              key_action = 2;
            }else {
              key_action = 1;
            }
            if (is_agree_receive != 1){
              //nếu ko có trạng thái nào đồng ý tiếp nhận thì chuyển sang hoàn thành
              params.process_status = this.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.COMPLETE;
            }
          queryUpsertProduct = `
          insert_core_warranty_repair_product_serial_number (
              objects: $core_warranty_repair_product_serial_number_upsert,
              on_conflict: {
                constraint: core_warranty_repair_product_serial_number_pkey,
                update_columns: [type_service,list_img_status_product,process_status,modifier_id,modified_date]
                }
              ) {
            returning {
              id process_status type_service check_maintenance_period
            }
          }
          `;
          params.receive_note = (!this.$myConstants.isEmpty(this.objectDataWarrantyRepair.receive_note)) ? this.objectDataWarrantyRepair.receive_note : '';
          params.receive_method = (!this.$myConstants.isEmpty(this.objectDataWarrantyRepair.receive_method)) ? parseFloat(this.objectDataWarrantyRepair.receive_method) : 0;
          if (status_update == this.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.WAITING_IMPLEMENTATION) {
            params.receive_day_reception = this.$myConstants.convertDate(this.objectDataWarrantyRepair.receive_day_reception);
            params.receive_sender = this.objectDataWarrantyRepair.receive_sender;
            params.modifier_id = this.$store.getters.fullname.id;
            params.modified_date = this.$myConstants.currentDate();
            params.receive_user_id = this.objectDataWarrantyRepair.receive_user_id;
            if (this.objectDataWarrantyRepair.receive_sender == 1){
              //lấy id đơn vị
              var receive_organization = await this.$coreService.get_organization_by_user_id(this.objectDataWarrantyRepair.receive_user_id);
              //console.log("receive_organization:",receive_organization);
              params.receive_organization_id = (!this.$myConstants.isEmpty(receive_organization)) ? receive_organization.organization_id:null;
            }

            if (this.objectDataWarrantyRepair.receive_method == '0') {
              params.delivery_return_appointment_day = this.$myConstants.convertDate(this.objectDataWarrantyRepair.delivery_return_appointment_day);
              params.delivery_method = parseFloat(this.objectDataWarrantyRepair.delivery_method);
              //delivery_organization_id
                var delivery_relative_receiving = this.objectDataWarrantyRepair.delivery_relative_receiving;
               params.delivery_relative_receiving = delivery_relative_receiving;
              switch (delivery_relative_receiving) {
                case 0:
                  // Người gửi  || nếu chọn người gửi thì lấy
                  /*if (this.objectDataWarrantyRepair.receive_sender == 0){
                    params.delivery_relative_receiving = 1;//set loại khách hàng
                  }else if (this.objectDataWarrantyRepair.receive_sender == 1){
                    params.delivery_relative_receiving = 2;//Nhân viên đại lý
                  }*/
                  params.delivery_user_id = this.objectDataWarrantyRepair.delivery_user_id;
                  break;
                case 1:
                case 2:
                  // Khách hàng
                  params.delivery_user_id = this.objectDataWarrantyRepair.delivery_user_id;
                  /*// nhân viên đại lý
                  params.delivery_organization_id = this.objectDataWarrantyRepair.delivery_organization_id;*/
                  break;
                default:
                  // code block
              }
              //nếu giao tận nơi người nhận thì bắt buộc nhập địa chỉ
              if (this.objectDataWarrantyRepair.delivery_method == '1') {
                params.delivery_province_id = this.objectDataWarrantyRepair.delivery_province_id;
                params.delivery_district_id = this.objectDataWarrantyRepair.delivery_district_id;
                params.delivery_ward_id = this.objectDataWarrantyRepair.delivery_ward_id;
                params.delivery_apartment_number = this.objectDataWarrantyRepair.delivery_apartment_number.trim();
              }
              if (delivery_relative_receiving == 2 || (delivery_relative_receiving == 0 && this.objectDataWarrantyRepair.receive_sender==1)){
                //lấy id đơn vị
                var delivery_organization =await vm.$coreService.get_organization_by_user_id(vm.objectDataWarrantyRepair.delivery_user_id);
                //console.log("delivery_organization:",delivery_organization);
                params.delivery_organization_id = (!vm.$myConstants.isEmpty(delivery_organization)) ? delivery_organization.organization_id:null;
              }
            }

          }
          break;

        default:
          // code block
      }
      this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      var list_product_old = resObj.arr_warranty_repair_product_serial_number;
      var map_status_product_old = {};
      for (var n=0;n<list_product_old.length;n++){
        map_status_product_old["k_"+list_product_old[n].id] = list_product_old[n].process_status;
      }
      //console.log("map_status_product_oldmap_status_product_old:",map_status_product_old)
      var queryUpdateStatus = `
        mutation update_core_warranty_repair_multil($core_warranty_repair_object: core_warranty_repair_set_input,$core_warranty_repair_product_serial_number_upsert:[core_warranty_repair_product_serial_number_insert_input!]!) {
          update_core_warranty_repair(where: { id: {_eq: "${warranty_repair_id}"}}, _set: $core_warranty_repair_object) {
            affected_rows
            returning {
              id
              arr_warranty_repair_product_serial_number { id process_status type_service check_maintenance_period }
            }
          }
          ${queryUpsertProduct}
        }
          `;
      var variablesUpdateStatus = {
        "variables": JSON.stringify({
          core_warranty_repair_object: params,
          core_warranty_repair_product_serial_number_upsert: list_upsert_product,
        })
      };
      DataServices.executeQuery('warranty_repair', queryUpdateStatus, variablesUpdateStatus).then(async (resdata) => {
        var organization = this.$myConstants.organizationUserLogin();
        var creator_organization_id = (!vm.$myConstants.isEmpty(organization.id)) ? organization.id:null;
        if (!vm.$myConstants.isEmpty(resdata.update_core_warranty_repair)) {
          if (!vm.$myConstants.isEmpty(resdata.update_core_warranty_repair.returning[0])) {
            //Nếu sản phẩm đồng ý tiếp nhận mới update lịch sử
            var variables_product_serial_number = {
              where_key: {
                warranty_repair_id: {_eq: warranty_repair_id},
                status: {_eq: 1}
              },
              orderBy: {"id": "asc"}
            }
            var get_data_product_serial =await DataServices.getList('warranty_repair_product_serial_number', {"variables": JSON.stringify(variables_product_serial_number)});
            var arr_wr_psn = get_data_product_serial[Object.keys(get_data_product_serial)];
            //var arr_wr_psn = resdata.update_core_warranty_repair.returning[0].arr_warranty_repair_product_serial_number;
            var map_status = {
              "k_5":8,
              "k_6":9,
              "k_7":10,
              "k_8":11,
            };
            if (key_action == 1){
              for (var t = 0; t < arr_wr_psn.length; t++) {
                var list_id_status_update = [];
                list_id_status_update.push(
                    arr_wr_psn[t].id
                );
                var process_status_log = map_status["k_"+arr_wr_psn[t].process_status];
                await vm.$coreService.updateHistoryWarrantyRepairProductSn('Chờ tiếp nhận sản phẩm', list_id_status_update, process_status_log, vm.$store.getters.fullname.id);
                //list_wr_product_serial_number_id.push(arr_wr_psn[k].id);
              }
              await vm.$coreService.sendPushNotification('repair_product_confirmation',[warranty_repair_id])
            }else if(key_action == 2){
              //console.log("arr_wr_psnarr_wr_psnarr_wr_psn:",arr_wr_psn)
              var arr_update_history = [];
              var list_maintenance_period = [];
              for (var h = 0; h < arr_wr_psn.length; h++) {
                if (arr_wr_psn[h].process_status == vm.$dataCommon.WARRANTY_REPAIR.PRODUCT_STATUS.WAITING_IMPLEMENTATION){
                  arr_update_history.push(arr_wr_psn[h].id)
                  if (arr_wr_psn[h].type_service == vm.$dataCommon.WARRANTY_REPAIR.TYPE_SERVICE.MAINTENANCE){
                    list_maintenance_period.push(arr_wr_psn[h].check_maintenance_period)
                  }
                }else {
                  //check trạng thái có bị thay đổi không nếu bị thay đổi update lịch sử
                  // console.log("map_status_product_old[k_+arr_wr_psn[h].id:",map_status_product_old["k_"+arr_wr_psn[h].id])
                  // console.log("arr_wr_psn[h].process_status",arr_wr_psn[h].process_status)
                  if (parseFloat(map_status_product_old["k_"+arr_wr_psn[h].id]) != parseFloat(arr_wr_psn[h].process_status)){
                    await vm.$coreService.updateHistoryWarrantyRepairProductSn('Tiếp nhận dịch vụ',[arr_wr_psn[h].id],map_status["k_"+arr_wr_psn[h].process_status],vm.$store.getters.fullname.id);
                  }
                }
              }
              if (arr_update_history.length > 0){
                await vm.$coreService.updateHistoryWarrantyRepairProductSn('Tiếp nhận dịch vụ',arr_update_history,0,vm.$store.getters.fullname.id);
              }
              if (list_maintenance_period.length > 0){
                await vm.$coreService.updateStatusMaintence(vm.$dataCommon.MAINTENANCE.PROCESS_STATUS.PROCESSING,list_maintenance_period,vm.$store.getters.fullname.id,creator_organization_id);
              }
            }
            else {
              var list_wr_product_serial_number_id = [];
              for (var k = 0; k < arr_wr_psn.length; k++) {
                if (arr_wr_psn[k].process_status != vm.$dataCommon.WARRANTY_REPAIR.PRODUCT_STATUS.DISCLAIMER && arr_wr_psn[k].process_status != vm.$dataCommon.WARRANTY_REPAIR.PRODUCT_STATUS.SUPPORT_DONE){
                  list_wr_product_serial_number_id.push(arr_wr_psn[k].id);
                }
              }
              if (status_update == 3){
                await vm.$coreService.updateHistoryWarrantyRepairProductSn('Đã xử lý xong tất cả sản phẩm trong danh sách', list_wr_product_serial_number_id, 6, vm.$store.getters.fullname.id);
                await vm.$coreService.sendPushNotification('repair_confirmation_waiting_delivery',[warranty_repair_id])
              }else if (status_update == 4){
                await vm.$coreService.updateHistoryWarrantyRepairProductSn('Giao trả sản phẩm thành công', list_wr_product_serial_number_id, 7, vm.$store.getters.fullname.id);
              }
            }
            //lưu lịch sử tiến độ
            //await vm.insertProcessWR(warranty_repair_id,params.process_status);
            await vm.$coreService.insertProcessWR(warranty_repair_id,params.process_status,vm.$store.getters.fullname.id,creator_organization_id);
            //console.log(is_reload)
            if (is_reload == 1){
              location.reload();
            }else {
              vm.$router.push({path: '/admin/warranty-repair'});
            }
          }
        }
      }).catch(async (err) => {
        console.log("errerrerrerrerrerrerr:",err)
        vm.$toast.add({
          severity: 'error',
          summary: 'Thông báo',
          detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
          life: 3000
        });
      });
    },
    toastErrCommon(){
      this.$toast.add({
        severity: 'error',
        summary: 'Thông báo',
        detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
        life: 3000
      });
    },
    async saveData(is_reload=false) {
      var vm = this;
      this.submitForm = true;
      await this.validationData();
      if (Object.entries(this.validationErrors).length === 0) {
        this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
        this.$store.commit('setLoading', true);
        var organization = this.$myConstants.organizationUserLogin();
        var creator_organization_id = (!this.$myConstants.isEmpty(organization.id)) ? organization.id:null;
        var params = {
          receive_day_reception: this.$myConstants.convertDate(this.objectDataWarrantyRepair.receive_day_reception),
          receive_sender: this.objectDataWarrantyRepair.receive_sender,
          receive_method: parseFloat(this.objectDataWarrantyRepair.receive_method),
          receive_note: this.objectDataWarrantyRepair.receive_note,
          process_status: 2,//chờ thực hiện
          status: 1,
          modifier_id: this.$store.getters.fullname.id,
          creator_organization_id: creator_organization_id,
          creator_id: this.$store.getters.fullname.id,
          modified_date: this.$myConstants.currentDate(),
          created_date: this.$myConstants.currentDate(),
        }
        params.receive_user_id = this.objectDataWarrantyRepair.receive_user_id;
        if (this.objectDataWarrantyRepair.receive_sender == 1){
          //lấy id đơn vị
          var receive_organization = await this.$coreService.get_organization_by_user_id(this.objectDataWarrantyRepair.receive_user_id);
          //console.log("receive_organization:",receive_organization);
          params.receive_organization_id = (!this.$myConstants.isEmpty(receive_organization)) ? receive_organization.organization_id:null;
        }

        /*var receive_sender = this.objectDataWarrantyRepair.receive_sender;
        switch (receive_sender) {
          case 0:
            // khách hàng
            params.receive_user_id = this.objectDataWarrantyRepair.receive_user_id;
            break;
          case 1:
            // nhân viên đại lý
            params.receive_organization_id = this.objectDataWarrantyRepair.receive_organization_id;
            break;
          default:
            // code block
        }*/
        if (this.objectDataWarrantyRepair.receive_method == '0') {
          params.delivery_return_appointment_day = this.$myConstants.convertDate(this.objectDataWarrantyRepair.delivery_return_appointment_day);
          params.delivery_method = parseFloat(this.objectDataWarrantyRepair.delivery_method);
          //delivery_organization_id
          var delivery_relative_receiving = this.objectDataWarrantyRepair.delivery_relative_receiving;
          params.delivery_relative_receiving = delivery_relative_receiving;
          switch (delivery_relative_receiving) {
            case 0:
              // Người gửi  || nếu chọn người gửi thì lấy
              /*if (this.objectDataWarrantyRepair.receive_sender == 0){
                params.delivery_relative_receiving = 1;//set loại khách hàng
              }else if (this.objectDataWarrantyRepair.receive_sender == 1){
                params.delivery_relative_receiving = 2;//Nhân viên đại lý
              }*/
              params.delivery_user_id = this.objectDataWarrantyRepair.delivery_user_id;
              break;
            case 1:
            case 2:
              // Khách hàng
              params.delivery_user_id = this.objectDataWarrantyRepair.delivery_user_id;
              /*// nhân viên đại lý
              params.delivery_organization_id = this.objectDataWarrantyRepair.delivery_organization_id;*/
              break;
            default:
              // code block
          }
          //nếu giao tận nơi người nhận thì bắt buộc nhập địa chỉ
          if (this.objectDataWarrantyRepair.delivery_method == '1') {
            params.delivery_province_id = this.objectDataWarrantyRepair.delivery_province_id;
            params.delivery_district_id = this.objectDataWarrantyRepair.delivery_district_id;
            params.delivery_ward_id = this.objectDataWarrantyRepair.delivery_ward_id;
            params.delivery_apartment_number = this.objectDataWarrantyRepair.delivery_apartment_number.trim();
          }
        }

        if (params.delivery_relative_receiving == 2 || (params.delivery_relative_receiving == 0 && this.objectDataWarrantyRepair.receive_sender==1)){
          //lấy id đơn vị
          var delivery_organization =await this.$coreService.get_organization_by_user_id(this.objectDataWarrantyRepair.delivery_user_id);
          //console.log("delivery_organization:",delivery_organization);
          params.delivery_organization_id = (!this.$myConstants.isEmpty(delivery_organization)) ? delivery_organization.organization_id:null;
        }
        /*var test = 1;
        if (test == 1){
          console.log("asdasd:",params);
          return false;
        }*/

        params.code = await this.getCodeNext();
        var list_data_product_insert = [];
        var list_product_serial = this.list_product_serial.listData;
        var str_serial_number = "";
        var list_maintenance_period = [];
        if (list_product_serial.length > 0) {
          for (var i = 0; i < list_product_serial.length; i++) {
            str_serial_number += (i == (list_product_serial.length - 1)) ? "#" + list_product_serial[i].serial_number + "#" : "#" + list_product_serial[i].serial_number+"#,";
            var itemDataInsert = {
              serial_number_id: list_product_serial[i].id,
              process_status: 0,//chờ thự hiện
              type_service: list_product_serial[i].type_service,
              desc_status_product: list_product_serial[i].desc_status_product,
              status: 1,
              modifier_id: this.$store.getters.fullname.id,
              creator_id: this.$store.getters.fullname.id,
              modified_date: this.$myConstants.currentDate(),
              created_date: this.$myConstants.currentDate(),
            }
            if (list_product_serial[i].type_service == vm.$dataCommon.WARRANTY_REPAIR.TYPE_SERVICE.MAINTENANCE){
              itemDataInsert.check_maintenance_period = list_product_serial[i].maintenance_period;
              list_maintenance_period.push(list_product_serial[i].maintenance_period);
            }
            if (list_product_serial[i].object_data.object_info_product){
              var object_info_product = list_product_serial[i].object_data.object_info_product;
              //console.log("object_info_product:",object_info_product)
              itemDataInsert.serial_user_id = (object_info_product.user_id) ? object_info_product.user_id:null;
              //lưu thông tin customer lại
              var obj_customer = {
                id:(object_info_product.user_id) ? object_info_product.user_id:null,
                full_name:(object_info_product.full_name) ? object_info_product.full_name:"",
                phone_number:(object_info_product.phone_number_root) ? object_info_product.phone_number_root:null,
                customer_type:(object_info_product.customer_type) ? object_info_product.customer_type:"",
              };
              itemDataInsert.info_customer_product_serial_number = JSON.stringify(obj_customer);
            }
            var list_img_status_product = list_product_serial[i].list_img_status_product;
            var list_image_upload = [];
            for (var h = 0; h < list_img_status_product.length; h++) {
              var obj_image = await this.$coreService.uploadOneImages(list_img_status_product[h]);
              list_image_upload.push(obj_image);
            }
            itemDataInsert.list_img_status_product = JSON.stringify(list_image_upload);

            list_data_product_insert.push(itemDataInsert);

          }
        }
        params.list_serial_number = str_serial_number;
        params.arr_warranty_repair_product_serial_number = {data: this.$myConstants.convertJsonObject(list_data_product_insert)};
        DataServices.insertData('warranty_repair_detail', {"variables": JSON.stringify({objects: params})}).then(async (resdata) => {
          if (!vm.$myConstants.isEmpty(resdata.insert_core_warranty_repair)){
          if (!vm.$myConstants.isEmpty(resdata.insert_core_warranty_repair.returning[0])) {
            var warranty_repair_id = resdata.insert_core_warranty_repair.returning[0].id;
            //Lấy danh sách id đề thêm lịch sử cập nhật
            var arr_wr_psn = resdata.insert_core_warranty_repair.returning[0].arr_warranty_repair_product_serial_number;
            var list_wr_product_serial_number_id = [];
            for (var k=0;k<arr_wr_psn.length;k++){
              list_wr_product_serial_number_id.push(arr_wr_psn[k].id);
            }
            await vm.$coreService.updateHistoryWarrantyRepairProductSn('Tiếp nhận dịch vụ',list_wr_product_serial_number_id,0,vm.$store.getters.fullname.id);
            //thêm lịch sử trạng thái sửa chữa
            //await vm.insertProcessWR(warranty_repair_id,2);
            await vm.$coreService.insertProcessWR(warranty_repair_id,2,vm.$store.getters.fullname.id,creator_organization_id);
            if (list_maintenance_period.length > 0){
              await vm.$coreService.updateStatusMaintence(vm.$dataCommon.MAINTENANCE.PROCESS_STATUS.PROCESSING,list_maintenance_period,vm.$store.getters.fullname.id,creator_organization_id);
            }
            if (is_reload == true){
              setTimeout(function(){
                window.location.href = window.origin +'/admin/warranty-repair/function/'+warranty_repair_id;
                }, 500);
            }else {
              vm.$router.push({path: '/admin/warranty-repair'});
            }
          }
          }//this.$store.commit('setLoading', true);
        }).catch(async (err) => {
          console.log("errerrerrerr:",err)
          vm.$toast.add({
            severity: 'error',
            summary: 'Thông báo',
            detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
            life: 3000
          });
          vm.submitForm = false;
        });
      } else this.submitForm = false;
    },
    async saveDataDelivery() {
      var vm = this;
      var warranty_repair_id = this.$route.params.id;
      var whereObject = {
        id: {'_eq': warranty_repair_id}
      }
      var resObj = await DataServices.getObjectData('warranty_repair_detail', whereObject, {id: 'desc'});
      if (resObj.process_status == this.$dataCommon.WARRANTY_REPAIR.PROCESS_STATUS.COMPLETE){
        this.$toast.add({
          severity: 'error',
          summary: 'Thông báo',
          detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
          life: 3000
        });
        return false;
      }
      if (resObj.receive_method == 1){
        //hình thức tận nơi ko cho update thông tin
        this.$toast.add({
          severity: 'error',
          summary: 'Thông báo',
          detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
          life: 3000
        });
      return false;
      }
      this.submitForm = true;
      await this.validationDataDelivery();
      if (Object.entries(this.validationErrors).length === 0) {
        this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
        this.$store.commit('setLoading', true);
        var params = {
          modifier_id: this.$store.getters.fullname.id,
          note_delivery: (!this.$myConstants.isEmpty(this.objectDataWarrantyRepair.note_delivery)) ? this.objectDataWarrantyRepair.note_delivery:'',
        };
        params.delivery_return_appointment_day = this.$myConstants.convertDate(this.objectDataWarrantyRepair.delivery_return_appointment_day);
        params.delivery_method = parseFloat(this.objectDataWarrantyRepair.delivery_method);
        //delivery_organization_id
        var delivery_relative_receiving = this.objectDataWarrantyRepair.delivery_relative_receiving;
        params.delivery_relative_receiving = delivery_relative_receiving;
        switch (delivery_relative_receiving) {
          case 0:
            // Người gửi  || nếu chọn người gửi thì lấy
            /*if (this.objectDataWarrantyRepair.receive_sender == 0){
              params.delivery_relative_receiving = 1;//set loại khách hàng
            }else if (this.objectDataWarrantyRepair.receive_sender == 1){
              params.delivery_relative_receiving = 2;//Nhân viên đại lý
            }*/
            params.delivery_user_id = this.objectDataWarrantyRepair.delivery_user_id;
            break;
          case 1:
          case 2:
            // Khách hàng
            params.delivery_user_id = this.objectDataWarrantyRepair.delivery_user_id;
            /*// nhân viên đại lý
            params.delivery_organization_id = this.objectDataWarrantyRepair.delivery_organization_id;*/
            break;
          default:
            // code block
        }
        //nếu giao tận nơi người nhận thì bắt buộc nhập địa chỉ
        if (this.objectDataWarrantyRepair.delivery_method == '1') {
          params.delivery_province_id = this.objectDataWarrantyRepair.delivery_province_id;
          params.delivery_district_id = this.objectDataWarrantyRepair.delivery_district_id;
          params.delivery_ward_id = this.objectDataWarrantyRepair.delivery_ward_id;
          params.delivery_apartment_number = this.objectDataWarrantyRepair.delivery_apartment_number.trim();
        }
        if (params.delivery_relative_receiving == 2 || (params.delivery_relative_receiving == 0 && this.objectDataWarrantyRepair.receive_sender == 1)) {
          //lấy id đơn vị
          var delivery_organization = await this.$coreService.get_organization_by_user_id(this.objectDataWarrantyRepair.delivery_user_id);
          //console.log("delivery_organization:",delivery_organization);
          params.delivery_organization_id = (!this.$myConstants.isEmpty(delivery_organization)) ? delivery_organization.organization_id : null;
        }
        DataServices.updateData('warranty_repair_detail', {
          "variables": JSON.stringify({
            data_update: params,
            where_key: {id: {'_eq': warranty_repair_id}}
          })
        }).then(async () => {
          vm.$toast.add({severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000})
          this.$store.commit('setLoading', false);
          vm.submitForm = false;
        }).catch(async () => {
          this.$store.commit('setLoading', false);
          vm.$toast.add({
            severity: 'error',
            summary: 'Thông báo',
            detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
            life: 3000
          });
          vm.submitForm = false;
        });
      } else this.submitForm = false;
    },
  }
}
</script>
<style lang="scss">
.title_group{
  font-weight: 700; font-style: normal; font-size: 16px!important;color: #333333;
}
.box-top-list {
  border: 1px solid #ccc;
  border-bottom: 0px;
  padding: 10px;

  span {
    font-size: 25px;
    text-align: left;
    display: inline-block;
  }

  .right-button {
    float: right;

    span {
      font-size: 14px;
    }

    .p-button {
      border-radius: 5px;
      min-width: 100px;

      &.btn-custom {
        margin-left: 10px;
      }

      span {
        text-align: center;
      }
    }
  }
}

.list-data-permission {
  border: 1px solid #ccc;
  border-top: 0;

  .box-tabview {
    padding: 0.5em 1em;
    width: 100%;

    .row-item-header {
      div {
        display: inline-block;
        border: 1px solid #e9ecef;
        border-width: 1px 0 0 0;
        font-weight: 600;
        color: #495057;
        background: #f8f9fa;
        transition: box-shadow 0.2s;
        padding: 0.571rem 0.857rem;
      }
    }

    .row-body {
      .row-item {
        border: 1px solid #e9ecef;
        border-width: 1px 0 0 0;
        padding: 0.571rem 0.857rem;

        .item {
          display: inline-block;
          color: #495057;
          transition: box-shadow 0.2s;
        }
      }

      &:last-child {
        .row-item {
          &:last-child {
            border-bottom: 1px solid #e9ecef;
          }
        }
      }
    }
  }
}

.group_radio_button {
  margin-left: 30px;

  .radio_product_apply {
    position: relative;

    .radio_lable_product_apply {
      position: absolute;
      left: 30px;
      top: 3px;
    }
  }

  .p-radiobutton .p-radiobutton-box .p-radiobutton-icon{
    color: #007ad9;
  }
  .p-radiobutton .p-radiobutton-box.p-highlight{
    background: #ffffff;
  }
}

.box_add_option {
  background-color: rgba(242, 242, 242, 1);
  border-radius: 10px;
  margin: 0px;
  padding: 15px;

  .box_input {
    padding: 0px;
    width: calc(100% - 120px);

    .box_title {
      position: relative;
      height: 20px;
      margin-bottom: 2px;
      .title_input {
        font-size: 14px;
        position: absolute;
        left: 0px;
      }

      .add_service_supplies {
        font-size: 14px;
        position: absolute;
        right: 0px;
        font-family: 'Arial Italic', 'Arial';
        font-weight: 400;
        font-style: italic;
        cursor: pointer;
      }
    }
  }

  .add_btn_data {
    position: relative;
    width: 100px;
    height: 40px;
    background: inherit;
    background-color: rgba(0, 153, 255, 1);
    border: none;
    border-radius: 5px;
    margin-right: 10px;
    margin-left: 10px;
    margin-top: 20px;

    .style_icon_add {
      position: absolute;
      margin-top: auto;
      margin-bottom: auto;
      top: 0;
      left: 0;
      bottom: 0;
      margin-left: 14px;
    }

    .style_text {
      position: absolute;
      margin-top: auto;
      margin-bottom: auto;
      top: 0;
      bottom: 0;
      height: fit-content;
      font-family: 'Arial Bold', 'Arial';
      font-weight: 700;
      font-style: normal;
      font-size: 14px;
      color: #FFFFFF;
    }
  }
}
.style_lable{
  font-weight: 700;
}
td.right_td_unit_price{
  text-align: right !important;
}
.autocomplete-custom{
  height: 40px;
  input{border-right: none;border-top-right-radius: 0px !important; border-bottom-right-radius: 0px !important;}
  .p-autocomplete-dropdown{ background: transparent; border: 1px solid #a6a6a6; border-left: none;width: 50px;
    &:enabled:hover{background: transparent; border: 1px solid #a6a6a6; border-left: none;}
    span{font-weight: 900; font-size: 20px; color: #C0C0C0;
      &::before{ content: "\e908";}
    }
  }
}
.form-info{
  .message_err{
    text-align: right!important;font-weight: 400; font-style: italic; color: #FF0000; font-size: 14px;margin-bottom: 0px
  }
  .p-field{ padding: 10px;
    &:nth-child(n) {background: #E4E4E4;}
    &:nth-child(2n) {background: #fff;}
    label{ width: 200px; margin: 0;}
    .box-status{
      position: relative;
      background-color: rgba(153, 0, 204, 1);
      border-radius: 5px;
      text-align: center;
      //midle vertical
      display: inline-block;
      vertical-align: middle;
      padding-left: 9px;
      padding-right: 10px;
      padding-top: 2px;
      padding-bottom: 2px;
      .style-text-status{
        font-family: 'Arial Bold', 'Arial';
        font-weight: 700;
        font-style: normal;
        font-size: 14px;
        color: #FFFFFF;
      }
    }
    .box-value{
      width: calc(100% - 220px);//căn chỉnh để xuống thẳng hàng
      display: inline-block;
    }
  }
  .box-button{
    margin-top: 10px;
    .btn-done{
      width: 120px;
      float: left;
      margin-right: 32px;
      background: linear-gradient(180deg, rgba(66, 139, 202, 1) 0%, rgba(66, 139, 202, 1) 0%, rgba(45, 108, 162, 1) 100%, rgba(45, 108, 162, 1) 100%) !important;
      border: 1px solid #428bca;
      font-family: 'Arial Bold', 'Arial';
      font-weight: 700;
      font-style: normal;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 24px;
    }
    .btn-false-report{
      width: 120px;
      background: linear-gradient(180deg, rgb(240, 173, 78) 0%, rgba(240, 173, 78, 1) 0%, rgba(235, 147, 22, 1) 100%, rgba(235, 147, 22, 1) 100%);
      border: 1px solid #F0AD4E;
      font-family: 'Arial Bold', 'Arial';
      font-weight: 700;
      font-style: normal;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 24px;
    }
  }
}
.box_add_customer{
  width: 56px; height: 40px;background-color: rgba(0, 153, 255, 1);float: right;display: flex; justify-content: center; align-items: center;border-radius: 5px;cursor: pointer;
img{
  height: 20px;width: 28px;
}
}
.list_product_serial {
  .p-filter-column{
    display: none;
  }
}
.boder-left{
  border-left: 1px solid;
}
</style>
<style>
.remove_scroll_list_serial .p-datatable-auto-layout > .p-datatable-wrapper{
  overflow-x: unset !important;/*bỏ croll ngang table ảnh hưởng đến show dropdown lên*/
}
 input[disabled="disabled"], textarea[disabled="disabled"] {
  font-weight: 700;
  font-style: normal;
  font-size: 13px;
  text-decoration: none;
  color: #000000;
  background: none !important;
  opacity: 0.9 !important;
}
</style>